import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { FormalizeCompany, FormalizeRequisition } from 'src/app/core/models/formalizePayload';
import { JobSalary } from 'src/app/core/models/jobSalary';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobService } from 'src/app/core/services/job.service';
import { ManageSkillsService } from 'src/app/core/services/manage-skills.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { RequisitionService } from 'src/app/core/services/requisition.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { UibModalService } from 'src/app/core/services/uibModalService';
import { UploadReqAddEditEndClientModalService } from 'src/app/core/services/upload-req-add-edit-end-client-modal.service';
import { UploadReqJobProfileModalService } from 'src/app/core/services/upload-req-job-profile-modal.service';
import { UploadReqTransactionCandidatesModalService } from 'src/app/core/services/upload-req-transaction-candidates-modal.service';
import { UploadReqUpdateLocationModalService } from 'src/app/core/services/upload-req-update-location-modal.service';
import { UploadReqWorkFlowStepWarningModalService } from 'src/app/core/services/upload-req-work-flow-step-warning-modal.service';
import { UserService } from 'src/app/core/services/user.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { Job } from 'src/app/public/app/models/job';
import { Requisition } from 'src/app/public/app/models/requisition';
import { RunCandidateScore } from 'src/app/public/app/models/runCandidateScore';
import { SentAssessmentDetail } from 'src/app/public/app/models/sentAssessmentDetail';
import { UiError } from 'src/app/public/app/models/uiError';
import { UploadReqStepUploadComponent } from './upload-req-step-upload/upload-req-step-upload.component';

declare var angular: any;
declare var $: any;

@Component({
    selector: 'app-upload-req-page',
    templateUrl: './upload-req-page.component.html'
})
export class UploadReqPageComponent implements OnInit {

    @Input() $transition$: any;

    MESSAGECONSTANTS: any = MESSAGECONSTANTS;

    // state params
    stateParams: any;
    isNewReq: any;
    asyncActionType: string;
    companyId: any;
    userId: any;

    // top-level flags
    isLoading: boolean;
    isJobFetched: boolean;
    isUploadRequisition: boolean;
    isTransitionAbortRequired: boolean;
    userDetails: any;
    isLocationChange: boolean;
    isLocationChangeInitial: boolean;
    sharedCorporateId: any;
    showWizardSteps: boolean;
    currentJobStatus: string;
    editModeFlag: boolean;
    isInitialStateDraft: boolean;
    isCorporate: boolean;
    clientOrBUIsRequiredFlag: boolean;
    clientOrBuLabel: string;
    isClientOrBuDisabled: boolean;
    isFileUploadEnabled: boolean;
    disableUploadButtonFlag: boolean;
    fileExistsFlag: boolean;
    savingFlag: boolean;
    step2DetailsSavedFlag: boolean;
    workflowStepsSavedFlag: boolean;
    jobBoardsSettingsSavedFlag: boolean;
    disableSaveButtonFlag: boolean;
    disableNextButtonFlag: boolean;
    disableCancelButtonFlag: boolean;
    disableAllButtonsFlag: boolean;
    fileUploadInProgressFlag: boolean;
    loadingAdjustedCandidatesCountFlag: boolean;
    isResumePullEnabled: boolean;
    isJobBoardSelected: boolean;
    isJobIntegrationEnabledByPlan: boolean;
    isTrialPlanActive: boolean;
    isJobBoardServiceUp: boolean;
    isActivateRequisitionEnabled: boolean;
    isFutureMatchesOnly: boolean;
    isOutreachEnabled: boolean;
    sendOutreachEmail: boolean;
    scoringInProgress: boolean;
    isStepOneActive: boolean;
    disableWorkflowSettings: boolean;
    isRecalcucateScoreNoClicked: boolean;
    isSkillsChanged: boolean;
    isUploadAndEditRadioBtn: boolean;
    isEditRequisitionDetails: boolean;

    // step 2 (recruiters/general info)
    editTitleFlag: boolean;
    editBUFlag: boolean;
    pocs: any[];
    vendorsList: any[];
    primaryHiringManagerList: any[];
    primaryHiringManagerId: any;
    isManageEndClient: boolean;
    isLoadingEndClientSearch: boolean;
    endClientTypeAheadResults: any[];
    addEditClientName: string;
    endClientSearchText: string;
    associatedEdClientReqDetails: any[];
    isEndClientNameValid: boolean;
    step2Submitted: boolean;
    step2RequiredFieldsValid: boolean;
    hasClientOrBuChanged: boolean;
    hasJobTypeChanged: boolean;
    isJobTypeChanged: boolean;
    candidatesPresentOnJob: boolean;
    selectedJobType: string;
    isJobLocationChanged: boolean;
    isAsyncProcess: boolean;
    isUiCanExit: boolean;
    step2RequestWasInProgressFlag: boolean;

    // wizard navigation engine (native replacement for the jQuery/Fuel-UX `.wizard()` plugin)
    currentStep: number;

    // step 1 (upload) - Dropzone
    @ViewChild(UploadReqStepUploadComponent) uploadReqStepUpload: UploadReqStepUploadComponent;
    reqUploadDropzone: any;
    dropzoneConfig: DropzoneConfigInterface;
    private _pendingDropzoneFile: { fileName: string; fileSize: number } | null;
    forms: any;
    sharedClientBuOrCorp: any;

    // lists / lookups
    clientorbulist: any[];
    recruiterList: any[];
    hiringManagerList: any[];
    selectedRecruiters: any[];
    sharedJobPocs: any[];
    selectedPocs: any[];
    selectedHiringManagers: any[];
    selectedPrimaryHiringManager: any[];
    selectedVendors: any[];
    salaryDurationOptions: any[];
    currencyCodes: any[];
    allSalaryDurationOptions: any[];
    jobTypeList: any[];
    selectedJobTypes: any[];
    workLocationsList: any[];
    selectedWorkLocationsList: any[];
    sponsorshipList: any[];
    selectedSponsorships: any[];
    techAssessmentList: any[];
    valueAssessmentList: any[];
    jobBoardDetails: any[];
    jobBoardDetailsCopy: any[];
    sharedClientBus: any[];
    isLoadingSharedClientBus: boolean;
    isClientOrBuRequired: boolean;

    // requisition/job state
    req: any;
    job: any;
    salaryLabel: string;
    requisitionInfo: any;
    formalizeActivityPayload: any;

    // skills master lists (used by requisition-skills / typeahead)
    requisitionSkillsLoading: boolean;
    allExistingSkills: any[];
    allExistingDegrees: any[];
    allExistingFieldOfStudy: any[];
    allExistingRoles: any[];
    allExistingCertificates: any[];
    allExistingJDActionWords: any[];
    allUpdatedJDActionWords: any[];
    timePeriods: any[];
    skillsTimePeriods: any[];

    contractDurations: string[];

    // per-step temp/compare objects
    step1DetailsTempObject: any;
    step2DetailsTempObject: any;
    workflowStepsTempObject: any;
    jobBoardsSettingsTempObject: any;

    // per-step error objects
    step1Error: UiError;
    step2Error: UiError;
    step3Error: UiError;
    step4Error: UiError;
    step5Error: UiError;

    // job-board related
    jobBoardsResumePullLeft: number;
    jobBoardsPullResumePulled: number;
    resumesToPullPerJobBoardCountCopy: number;
    activeJobBoardsFilterTabNumber: number;
    resumePullCounts: number[];
    isJobBoardDetailsSet: boolean;
    jobBoardParameters: any;
    jobBoardParametersMatrix: any[];
    radiusOptions: any[];
    recencyOptions: any[];
    step4RequestWasInProgressFlag: boolean;

    // scoring
    currentScoreCandidateCounts: any;
    adjustedScoreCandidateCounts: any;
    candidatesBasedOnRequisitionTransaction: any[];

    // assessments
    sentTechnicalAssessmentsDetail: SentAssessmentDetail;
    sentValueAssessmentsDetail: SentAssessmentDetail;

    // step 3 (workflow) - license preferences / assessment / workflow-step-order state
    licensePreferenceDetails: any;
    intelligencePreferences: any;
    autoMatchingPreferences: any;
    recruiterScreeningPreferences: any;
    techAssessmentPreferences: any;
    valueAssessmentPreferences: any;
    verificationPreferences: any;
    phoneScreenPreferences: any;
    interviewPreferences: any;
    imageProctoringPreferences: any;
    addImagesToReportPreferences: any;
    isAnyWorkflowStepsEnabled: boolean;
    workflowStepsOrder: any;
    workflowStepsOrderToRender: any;
    isLicensePreferenceSet: boolean;
    isWorkFlowStep4Dot5ScoreChanged: boolean;
    step3Submitted: boolean;
    step3RequiredFieldsValid: boolean;
    step3RequestWasInProgressFlag: boolean;

    // end client
    endClient: any;

    constructor(
        public $state: StateService,
        private cdr: ChangeDetectorRef,
        private sanitizer: DomSanitizer,
        private authService: AuthService,
        private requisitionService: RequisitionService,
        private jobService: JobService,
        private resumeService: ResumeService,
        private planService: PlanService,
        private companyService: CompanyService,
        private assessmentService: AssessmentService,
        private candidateService: CandidateService,
        private alertsAndNotificationsService: AlertAndNotificationsService,
        private uibModalService: UibModalService,
        private utilityService: UtilityService,
        private userService: UserService,
        private manageSkillsService: ManageSkillsService,
        private uploadReqWorkFlowStepWarningModalService: UploadReqWorkFlowStepWarningModalService,
        private uploadReqUpdateLocationModalService: UploadReqUpdateLocationModalService,
        private uploadReqTransactionCandidatesModalService: UploadReqTransactionCandidatesModalService,
        private uploadReqJobProfileModalService: UploadReqJobProfileModalService,
        private uploadReqAddEditEndClientModalService: UploadReqAddEditEndClientModalService
    ) { }

    ngOnInit() {
        this.utilityService.showLoadingModal('Loading...');
        this.stateParams = this.$transition$.params();
        this.isNewReq = (!_.isUndefined(this.stateParams.isNewReq) && !_.isNull(this.stateParams.isNewReq)) ? this.stateParams.isNewReq : null;
        this.asyncActionType = this.stateParams.asyncActionType ? this.stateParams.asyncActionType : 'UPLOAD';
        this.isLoading = true;
        this.requisitionSkillsLoading = false;
        this.allExistingSkills = [];
        this.allExistingDegrees = [];
        this.allExistingFieldOfStudy = [];
        this.allExistingRoles = [];
        this.allExistingCertificates = [];
        this.allExistingJDActionWords = [];
        this.allUpdatedJDActionWords = [];
        this.timePeriods = [];
        this.skillsTimePeriods = [];
        this.getAllMasterLists(() => {
            this._initVariables();
            // TODO(step 8b): _initUploadWizard() - jQuery/Fuel-UX wizard init replaced by native step engine.
            // TODO(step 8b): _handleBrowserEvents().
            this._setContractDurations();

            this.getPlanDetails(() => {
                if (this.isTrialPlanActive) {
                    this.getJobBoardsResumePullLimits();
                }
            });
            this.getSalaryDurationOptions();
            this.getCurrencyCodes();
            this.checkJobBoardsSearchAvailability();
            if (!this.editModeFlag) {
                this.job = new Job();
                this.isJobFetched = true;
                this.showWizardSteps = true;
                this._ensureWizardInitialized();
                this.currentJobStatus = 'DRAFT';
                this.isActivateRequisitionEnabled = false;
                this.getAllClientsOrBu();
                this.getAllJobTypes();
                this.getAllWorkLocations();
                this.getAllSponsorshipTypes();
                this.getAllTechAssessments();
                this.getAllValueAssessments();
                this.getAllJobBoards();
                this._createStepTempObject(1);
                this.utilityService.hideLoadingModal();
            } else {
                this.getJob(this.stateParams.jobId, (data: any) => {
                    this.currentJobStatus = 'OPEN';
                    if (data.jobCurrentState === 'DRAFT') {
                        this.currentJobStatus = 'DRAFT';
                        this.isActivateRequisitionEnabled = false;
                    } else {
                        this._ensureWizardInitialized();
                    }
                    this.showWizardSteps = true;
                    this.req.title = data.title;
                    this.req.isSharedClientRequisition = data.isSharedClientRequisition;
                    this.req.sharedClientBuOrCorpId = data.sharedClientBuOrCorpId;
                    const fileName = this._getFileName(data);
                    const fileSize = data.jobRequisitionList[0].fileSize ? data.jobRequisitionList[0].fileSize : 0;

                    this.getJobScoringJobStatus();
                    this.getAllClientsOrBu(() => {
                        this._setClientOrBu(data.clientorbu);
                        this._createStepTempObject(2);
                        if (!this.isCorporate) {
                            this._getSharedClientBus(() => {
                                this.getPointOfContacts(() => {
                                    this._setPocs();
                                });
                            });
                        }
                    });

                    this.getRecruiters(() => {
                        this._setRecruitersAndHiringManagers();
                    });

                    if (!this.clientOrBUIsRequiredFlag) {
                        this.getBuVendors(() => {
                            this._setBuVendors();
                        });
                    }
                    this.getAllJobTypes(() => {
                        this._setJobType();
                    });

                    this.getAllWorkLocations(() => {
                        if (this.job.workLocationIds && this.job.workLocationIds.length > 0) {
                            this._setWorkLocations();
                        }
                    });
                    this.getAllSponsorshipTypes(() => {
                        if (this.job.sponsorships) {
                            if (this.job.sponsorships.length > 0) {
                                this._setSponsorshipType();
                            }
                        } else {
                            this._setSponsorshipSelectedDefault(false);
                        }
                    });
                    this.getAllTechAssessments();
                    this.getAllValueAssessments();
                    this.getAllJobBoards(() => {
                        this._setJobBoardDetails();
                    });
                    this.getLicensePreferences(() => {
                        this._createWorkflowSliders(() => {
                            this._massageWorkflowStepsOrder();
                        });
                        this.disableNextButtonFlag = false;
                    });
                    if (fileName) {
                        this._setFileInUploadDropZone(fileName, fileSize);
                    }
                    this.disableUploadButtonFlag = true;
                    this.fileExistsFlag = true;
                    this.step2DetailsSavedFlag = true;
                    this.workflowStepsSavedFlag = true;
                    this.jobBoardsSettingsSavedFlag = true;
                    if (this.isNewReq) {
                        this.utilityService.showLoadingModal('Loading...');
                        this._getCandidateCountBeforeStep5(() => {
                            this._createCountSliders();
                            this._advanceWizardToPreviousStep();
                            this.utilityService.hideLoadingModal();
                            this.disableSaveButtonFlag = false;
                        }, () => {
                            this.utilityService.hideLoadingModal();
                            this.disableSaveButtonFlag = false;
                        });
                    }
                    if (this.asyncActionType && this.asyncActionType !== 'UPLOAD') {
                        this.disableSaveButtonFlag = false;
                    }
                    this._createStepTempObject(1);
                    this.utilityService.hideLoadingModal();
                });
            }
            this._checkIfOutreachEnabled();
        });
        this.setFormalizeActivityPayload();
    }

    private _initVariables() {
        this.isJobFetched = false;
        this.isUploadRequisition = true;
        this.isTransitionAbortRequired = true;
        this.userDetails = this.authService.getUserDetails();
        this.isLocationChange = false;
        this.isLocationChangeInitial = false;
        this.sharedCorporateId = null;
        this.clientorbulist = [];
        this.recruiterList = [];
        this.hiringManagerList = [];
        this.selectedRecruiters = [];
        this.sharedJobPocs = [];
        this.selectedPocs = [];
        this.selectedHiringManagers = [];
        this.selectedPrimaryHiringManager = [];
        this.selectedVendors = [];
        this.salaryDurationOptions = [];
        this.currencyCodes = [];
        this.jobTypeList = [];
        this.selectedJobTypes = [];
        this.workLocationsList = [];
        this.selectedWorkLocationsList = [];
        this.sponsorshipList = [];
        this.selectedSponsorships = [];
        this.techAssessmentList = [];
        this.valueAssessmentList = [];
        this.jobBoardDetails = [];
        this.jobBoardDetailsCopy = [];
        this.allSalaryDurationOptions = [];
        this.resumesToPullPerJobBoardCountCopy = 0;
        this.currentScoreCandidateCounts = {};
        this.adjustedScoreCandidateCounts = {};
        this.candidatesBasedOnRequisitionTransaction = [];
        this.req = {};
        this.job = {};
        this.salaryLabel = 'Salary';
        this.currentJobStatus = null;
        this.jobBoardsResumePullLeft = 0;
        this.jobBoardsPullResumePulled = 0;
        this.activeJobBoardsFilterTabNumber = 0;
        this.clientOrBuLabel = 'Client';
        this.sharedClientBus = [];
        this.isLoadingSharedClientBus = false;
        this.isClientOrBuRequired = false;
        this.sentTechnicalAssessmentsDetail = new SentAssessmentDetail();
        this.sentValueAssessmentsDetail = new SentAssessmentDetail();
        this.resumePullCounts = [5, 10, 15, 20, 25];
        this.isJobBoardDetailsSet = false;
        this.jobBoardParameters = {};
        this.jobBoardParametersMatrix = [];
        this.radiusOptions = [];
        this.recencyOptions = [];
        this.step4RequestWasInProgressFlag = false;
        this.licensePreferenceDetails = null;
        this.intelligencePreferences = {};
        this.autoMatchingPreferences = {};
        this.recruiterScreeningPreferences = {};
        this.techAssessmentPreferences = {};
        this.valueAssessmentPreferences = {};
        this.verificationPreferences = {};
        this.phoneScreenPreferences = {};
        this.interviewPreferences = {};
        this.imageProctoringPreferences = {};
        this.addImagesToReportPreferences = {};
        this.isAnyWorkflowStepsEnabled = false;
        this.workflowStepsOrder = {};
        this.workflowStepsOrderToRender = {};
        this.isLicensePreferenceSet = false;
        this.isWorkFlowStep4Dot5ScoreChanged = false;
        this.step3Submitted = false;
        this.step3RequiredFieldsValid = true;
        this.step3RequestWasInProgressFlag = false;
        this.endClient = null;
        this.isCorporate = false;
        this.editModeFlag = false;
        this.disableWorkflowSettings = false;
        this.isClientOrBuDisabled = false;
        this.isFileUploadEnabled = true;
        this.isInitialStateDraft = false;
        this.clientOrBUIsRequiredFlag = true;
        this.disableUploadButtonFlag = true;
        this.fileExistsFlag = false;
        this.savingFlag = false;
        this.step2DetailsSavedFlag = false;
        this.workflowStepsSavedFlag = false;
        this.jobBoardsSettingsSavedFlag = false;
        this.disableSaveButtonFlag = true;
        this.disableNextButtonFlag = true;
        this.disableCancelButtonFlag = false;
        this.disableAllButtonsFlag = false;
        this.fileUploadInProgressFlag = false;
        this.loadingAdjustedCandidatesCountFlag = false;
        this.isResumePullEnabled = false;
        this.isJobBoardSelected = false;
        this.isJobIntegrationEnabledByPlan = false;
        this.isTrialPlanActive = false;
        this.isJobBoardServiceUp = true;
        this.isActivateRequisitionEnabled = true;
        this.isFutureMatchesOnly = true;
        this.isOutreachEnabled = false;
        this.sendOutreachEmail = false;
        this.scoringInProgress = false;
        this.showWizardSteps = false;
        this.step1DetailsTempObject = {};
        this.step2DetailsTempObject = {};
        this.workflowStepsTempObject = {};
        this.jobBoardsSettingsTempObject = {};
        this.step1Error = null;
        this.step2Error = null;
        this.step3Error = null;
        this.step4Error = null;
        this.step5Error = null;

        // set add or edit mode
        if (this.stateParams.jobId != null) {
            this.editModeFlag = true;
            this.isClientOrBuDisabled = true;
            this.isFileUploadEnabled = false;
            this.isUploadRequisition = false;
            this.disableSaveButtonFlag = false;
        }
        if (this.stateParams.jobState != null && (this.stateParams.jobState === 'Draft' || this.stateParams.jobState === 'DRAFT')) {
            this.isInitialStateDraft = true;
        }
        this.dropzoneConfig = {
            url: this.requisitionService.getUploadUrl(),
            paramName: 'file',
            acceptedFiles: '.pdf,.xlsx,.docx,.doc',
            maxFiles: 1,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            addRemoveLinks: true,
            autoProcessQueue: false,
            clickable: this.isFileUploadEnabled,
            timeout: 300000
        };
        // if corporate, set the BU required flag as false.
        if (this.userDetails.company.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE) {
            this.clientOrBUIsRequiredFlag = false;
            this.clientOrBuLabel = 'BU';
        }

        this.isCorporate = this.companyService.isCorporateCompany();
        this.req = new Requisition();
        this.companyId = this.userDetails.company.companyId;
        this.userId = this.userDetails.id;
        this.step1Error = new UiError();
        this.step2Error = new UiError();
        this.step3Error = new UiError();
        this.step4Error = new UiError();
        this.step5Error = new UiError();
        this.isStepOneActive = true;
        this.isRecalcucateScoreNoClicked = false;
        this.isSkillsChanged = false;
        this.isUploadAndEditRadioBtn = true;
        this.isEditRequisitionDetails = false;
        this.currentStep = 1;
        this.reqUploadDropzone = {};
        this._pendingDropzoneFile = null;
        this.sharedClientBuOrCorp = null;

        // step 2 (recruiters/general info)
        this.editTitleFlag = false;
        this.editBUFlag = false;
        this.pocs = [];
        this.vendorsList = [];
        this.primaryHiringManagerList = [];
        this.primaryHiringManagerId = '';
        this.isManageEndClient = false;
        this.isLoadingEndClientSearch = false;
        this.endClientTypeAheadResults = [];
        this.addEditClientName = '';
        this.endClientSearchText = '';
        this.associatedEdClientReqDetails = [];
        this.isEndClientNameValid = false;
        this.step2Submitted = false;
        this.step2RequiredFieldsValid = true;
        this.hasClientOrBuChanged = false;
        this.hasJobTypeChanged = false;
        this.isJobTypeChanged = false;
        this.candidatesPresentOnJob = false;
        this.selectedJobType = null;
        this.isJobLocationChanged = false;
        this.isAsyncProcess = false;
        this.isUiCanExit = false;
        this.step2RequestWasInProgressFlag = false;
    }

    private _setContractDurations() {
        this.contractDurations = ['1', '2', '3', '3+', '4', '5', '6', '6+', '7', '8', '9', '9+', '10', '11', '12', '12+', '15', '18', '21', '24', 'Long Term'];
    }

    getAllMasterLists(successCallback: () => void) {
        this.isLoading = true;
        let completedRequests = 0;
        const totalRequests = 6;

        const checkCompletion = () => {
            completedRequests++;
            if (completedRequests === totalRequests) {
                setTimeout(() => {
                    this.setTimePeriodsForTypeAhead();
                }, 50);
                setTimeout(() => {
                    this.isLoading = false;
                    if (successCallback) {
                        successCallback();
                    }
                }, 100);
            }
        };

        this.getAllSkills(() => checkCompletion());
        this.getDegreesEntities(() => checkCompletion());
        this.getFieldOfStudyEntities(() => checkCompletion());
        this.getRoles(() => checkCompletion());
        this.getCertificates(() => checkCompletion());
        this.getJdActions(() => checkCompletion());
    }

    getAllSkills(successCallback: () => void) {
        const filterObject = {
            searchSkill: '',
            searchByParentSkill: '',
            searchCategory: '',
            sortColumn: 'skill',
            sortDir: 'ASC',
            includeAlternateSkills: false
        };

        this.allExistingSkills = [];
        this.jobService.getAllSkills(filterObject, (data: any) => {
            this.allExistingSkills = data ? data.allSkills.filter((skill: any) => skill) : [];
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    getDegreesEntities(successCallback: () => void) {
        const degreeFilerObj = { searchDegree: '', sortColumn: '', sortDir: '' };
        this.allExistingDegrees = [];
        this.manageSkillsService.getAllDegreesEntityLists(degreeFilerObj, (data: any) => {
            this.allExistingDegrees = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    getFieldOfStudyEntities(successCallback: () => void) {
        const fieldOfStudyObj = { searchFieldOfStudy: '', sortColumn: '', sortDir: '' };
        this.manageSkillsService.getAllFieldOfStudyLists(fieldOfStudyObj, (data: any) => {
            this.allExistingFieldOfStudy = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    getRoles(successCallback: () => void) {
        const roleObj = { searchRole: '', sortColumn: '', sortDir: '' };
        this.manageSkillsService.getAllCandidateRolesLists(roleObj, (data: any) => {
            this.allExistingRoles = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    getCertificates(successCallback: () => void) {
        const certificatesObj = { searchName: '', sortColumn: '', sortDir: '' };
        this.manageSkillsService.getAllCertificationsLists(certificatesObj, (data: any) => {
            this.allExistingCertificates = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    getJdActions(successCallback: () => void) {
        const jdActionsObj = { searchName: '', sortColumn: '', sortDir: '' };
        this.manageSkillsService.getAllJdActionsLists(jdActionsObj, (data: any) => {
            this.allExistingJDActionWords = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    private setJDActionsValues(actionWord: any, key: string, fallbackKey = 'value') {
        return actionWord[key] ? actionWord[key][fallbackKey] : '';
    }

    private setJDActionWords() {
        this.allExistingJDActionWords.forEach((jdAction: any) => {
            if (jdAction.jobDescriptionLanguageDropdown && jdAction.jobDescriptionLanguageDropdown.length > 0) {
                jdAction.jobDescriptionLanguageDropdown.forEach((actionWord: any) => {
                    const actionWordTemp = { name: actionWord, jdAction };
                    this.allUpdatedJDActionWords.push(actionWordTemp);
                });
            }
        });

        const prepositions = [' in ', ' with ', ' of ', ' at '];

        this.allUpdatedJDActionWords.forEach((actionWord: any) => {
            prepositions.forEach((preposition) => {
                this.skillsTimePeriods.push({
                    name: `${actionWord.name}${preposition}`,
                    value: {
                        minExperienceInMonths: this.setJDActionsValues(actionWord.jdAction, 'minExperienceInMonths'),
                        maxExperienceInMonths: this.setJDActionsValues(actionWord.jdAction, 'maxExperienceInMonths'),
                        plusTo: this.setJDActionsValues(actionWord.jdAction, 'minExperienceInMonths', 'sign'),
                        months: 0,
                        range: '',
                        isJDActionWord: true,
                        jdAction: actionWord
                    }
                });
            });
        });
    }

    setTimePeriodsForTypeAhead() {
        this.timePeriods = this.manageSkillsService.setTimePeriodsInRequisitionSkillsTypeAhead() as any[];
        this.skillsTimePeriods = [];
        const timePeriodsWithExperience: any[] = [];
        this.timePeriods.forEach((skill: any) => {
            const tempSkill = { ...skill };
            this.skillsTimePeriods.push(tempSkill);

            const experienceInSkill = { ...skill, name: skill.name + 'experience in ' };
            this.skillsTimePeriods.push(experienceInSkill);

            const experienceWithSkill = { ...skill, name: skill.name + 'experience with ' };
            this.skillsTimePeriods.push(experienceWithSkill);

            const experienceOfSkill = { ...skill, name: skill.name + 'experience of ' };
            this.skillsTimePeriods.push(experienceOfSkill);

            const experienceSkill = { ...skill, name: skill.name + 'experience ' };
            timePeriodsWithExperience.push(experienceSkill);
        });

        this.setJDActionWords();
        this.timePeriods = [...this.timePeriods, ...timePeriodsWithExperience];
    }

    getPlanDetails(successCallback: () => void) {
        this.planService.getCompanyPlanDetails(this.companyId, (data: any) => {
            if (!_.isNull(data)) {
                if (data !== '' && !_.isNull(data.features) && data.features.length) {
                    const jobIntegrationDetails = _.find(data.features, { name: 'Job Board Integration', available: true });
                    this.isJobIntegrationEnabledByPlan = !_.isUndefined(jobIntegrationDetails);
                    if (!this.isJobIntegrationEnabledByPlan) {
                        this.isResumePullEnabled = false;
                    }
                    this.isTrialPlanActive = data.plan === 'Trial';
                    successCallback();
                }
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    getSalaryDurationOptions() {
        this.jobService.getSalaryDurationOptions((data: any) => {
            this.allSalaryDurationOptions = data;
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    getCurrencyCodes() {
        this.jobService.getCurrencyCodes((data: any) => {
            this.currencyCodes = data;
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    checkJobBoardsSearchAvailability() {
        this.jobService.checkJobBoardsSearchAvailability((data: any) => {
            this.isJobBoardServiceUp = data;
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    getJobBoardsResumePullLimits() {
        this.planService.getAvailableJobBoardsPullCount(this.companyId, (data: any) => {
            this.jobBoardsResumePullLeft = data.jobBoardResumesLeftCount;
            this.jobBoardsPullResumePulled = data.jobBoardResumesPulledCount;
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    private _checkIfOutreachEnabled() {
        // Legacy candidateService.getOutreachEmailEnabledStatus call is commented out upstream (dead code) -
        // preserved as-is: isOutreachEnabled is simply hardcoded true.
        this.isOutreachEnabled = true;
    }

    setFormalizeActivityPayload() {
        if (this.editModeFlag) {
            this.formalizeActivityPayload = {
                candidate: null,
                requisition: new FormalizeRequisition(this.job.id, this.job.requisitionNumber, this.job.title),
                jobMatch: null,
                company: new FormalizeCompany(this.job.company.id, this.job.company.name, this.job.clientorbu.id, this.job.clientorbu.name)
            };
        }
    }

    getJob(jobId: any, successCallback: (data: any) => void) {
        this.jobService.getJob(jobId, (data: any) => {
            // eslint-disable-next-line
            if ((this as any).editMcurrentJobStatus !== 'DRAFT') {
                // Preserved pre-existing legacy bug: `editMcurrentJobStatus` does not exist on the
                // controller (should presumably be `currentJobStatus`), so this branch is always taken.
                this.requisitionInfo = _.cloneDeep(data);
                this.requisitionInfo.workflowSteps = this.stateParams.workflowSteps;
                this.requisitionInfo.fourDotFiveIntelligentThresholdScore = this.stateParams.fourDotFiveIntelligentThresholdScore;
                this.requisitionInfo.vendorsDetails = this.stateParams.vendorsDetails;
                this.requisitionInfo.autoMatedMatchEnabled = true;
                this.requisitionInfo.autoMatedMatchSelected = false;
            }
            this.job = this._parseJobResponse(data);
            if (data.jobCurrentState === 'COMPLETED' || data.jobCurrentState === 'CANCELED') {
                this.disableWorkflowSettings = true;
            }
            successCallback(data);
        }, (error: any) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    private _parseJobResponse(data: any) {
        this.isJobFetched = true;
        const tempJob: any = new Job();
        tempJob.id = data.id;
        tempJob.title = data.title;
        tempJob.sharedClientBuOrCorpId = data.sharedClientBuOrCorpId;
        tempJob.isSharedClientRequisition = data.isSharedClientRequisition;
        tempJob.company = {
            name: data.company.name,
            id: data.company.id,
            shortName: data.company.shortName
        };
        if (_.isNull(data.clientorbu)) {
            tempJob.clientorbu = null;
        } else {
            tempJob.clientorbu = {
                name: data.clientorbu.name,
                id: data.clientorbu.id,
                shortName: data.clientorbu.shortName
            };
        }
        tempJob.requisitionNumber = data.requisitionNumber;
        tempJob.jobType = data.jobType;
        tempJob.contractDuration = data.contractDuration;
        tempJob.requisitionNote = data.requisitionNote;
        tempJob.jobSalary = _.cloneDeep(data.jobSalary);
        tempJob.location = data.location;
        tempJob.locationLabel = '-';
        if (!_.isNull(tempJob.location)) {
            if (!_.isNull(data.location.city)) {
                tempJob.locationLabel = data.location.city;
            }
            if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel === '-') {
                tempJob.locationLabel = data.location.state;
                if (_.isNull(tempJob.locationLabel)) {
                    tempJob.locationLabel = '-';
                }
            } else if (!_.isNull(data.location.state)) {
                tempJob.locationLabel += ', ' + data.location.state;
            }
            if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel === '-') {
                tempJob.locationLabel = data.location.zipcode ? data.location.zipcode : data.location.zipCode;
                if (_.isNull(tempJob.locationLabel)) {
                    tempJob.zipCode = '-';
                }
            } else if (data.location.zipcode || data.location.zipCode) {
                tempJob.locationLabel += ', ' + (data.location.zipcode ? data.location.zipcode : data.location.zipCode);
            }
        }
        // set the transaction id of the last requisition in the requisition list as job's transaction id
        tempJob.transactionId = data.jobRequisitionList[(data.jobRequisitionList.length - 1)].transactionId;
        tempJob.openings = data.numberOfOpenings;
        tempJob.sponsorships = data.sponsorships;
        tempJob.workLocationIds = data.workLocations ? data.workLocations.map((workLocation: any) => workLocation.id) : [];
        tempJob.workLocations = data.workLocations;
        tempJob.sponsorshipProvided = data.sponsorshipProvided;
        tempJob.recruiters = data.recruiters.map((recruiter: any) => recruiter.id);
        tempJob.hiringManagers = data.hiringManagers.map((manager: any) => ({ id: manager.user.id, isPrimary: manager.isPrimary }));
        tempJob.pointOfContactUserId = !_.isNull(data.pointOfContact) ? data.pointOfContact.id : null;
        // Set End Client
        tempJob.endClient = data.endClient;
        this._setEndClient(tempJob);
        tempJob.vendorIds = data.vendorIds;
        tempJob.educationList = data.educationList;
        tempJob.score = data.fourDotFiveIntelligenceScore;
        tempJob.licensePreferences = data.licensePreferences;
        tempJob.radius = data.radius;
        tempJob.recency = data.recency;
        tempJob.salary = data.salary;
        data.location.zipcode = null;
        tempJob.industry = data.industry;
        tempJob.workflowStepsOrder = data.workflowStepsOrder;
        if (!_.isNull(data.techAssessmentId) && this.stateParams.jobState !== 'Completed' && this.stateParams.jobState !== 'Canceled') {
            tempJob.techAssessmentId = data.techAssessmentId;
            tempJob.techAssessmentScore = data.techAssessmentScore;
            this._getSentAssessmentsCount(tempJob.techAssessmentId, 'Technical', tempJob.id);
        }
        if (!_.isNull(data.valueAssessmentId) && this.stateParams.jobState !== 'Completed' && this.stateParams.jobState !== 'Canceled') {
            tempJob.valueAssessmentId = data.valueAssessmentId;
            this._getSentAssessmentsCount(tempJob.valueAssessmentId, 'Value', tempJob.id);
        }
        tempJob.jobBoardDetails = _.cloneDeep(this.jobBoardDetails);
        if (!_.isNull(tempJob.licensePreferences) && !_.isNull(tempJob.licensePreferences.jobBoardDetails)) {
            tempJob.jobBoardDetails.forEach((val: any) => {
                if (_.findIndex(tempJob.licensePreferences.jobBoardDetails, { boardId: val.boardId, enabled: true }) === -1) {
                    val.enabled = false;
                }
            });
        }
        this.jobBoardDetailsCopy = _.cloneDeep(tempJob.jobBoardDetails);
        if (!_.isNull(tempJob.licensePreferences) && !_.isNull(tempJob.licensePreferences.resumesToPullPerJobBoardCount)) {
            tempJob.resumesToPullPerJobBoardCount = data.licensePreferences.resumesToPullPerJobBoardCount;
            this.resumesToPullPerJobBoardCountCopy = tempJob.resumesToPullPerJobBoardCount;
            tempJob.isResumePullEnabled = false;
        }
        tempJob.daxtraParameters = data.daxtraParameters;
        if (!(_.isNull(data.daxtraParameters) || _.isUndefined(data.daxtraParameters)) && !(_.isNull(data.advancedParametersImage) || _.isUndefined(data.advancedParametersImage))) {
            this.activeJobBoardsFilterTabNumber = 1;
        }
        // the template tests for null, which $sce passed through and bypassSecurityTrust* would wrap
        tempJob.advancedParametersImage = data.advancedParametersImage
            ? this.sanitizer.bypassSecurityTrustResourceUrl(data.advancedParametersImage)
            : data.advancedParametersImage;

        tempJob.salaryLabel = 'Salary Details';
        if (data.jobType && (data.jobType === 'CONTRACTOR' || data.jobType === 'CONTRACTTOHIRE')) {
            tempJob.salaryLabel = this.isCorporate || tempJob.isSharedClientRequisition ? 'Bill Rate' : 'Client/Bill Rate';
        }
        tempJob.jobTypeLabel = (data.jobType && this.jobTypeList.length > 0) ? this.jobTypeList.filter((jobType: any) => jobType.value === data.jobType)[0].name : null;
        tempJob.requisitionSalaryDisplayMessage = this._getSalaryDetailsDisplayMessage(tempJob.jobSalary ? tempJob.jobSalary : new JobSalary(), this.allSalaryDurationOptions);
        if (_.isNull(tempJob.sponsorshipProvided) || _.isUndefined(tempJob.sponsorshipProvided)) {
            tempJob.sponsorshipsDisplayMessage = 'Sponsorship information not specified';
        } else if (_.isNull(tempJob.sponsorships) || tempJob.sponsorships.length === 0) {
            tempJob.sponsorshipsDisplayMessage = 'Not Available';
        } else if (tempJob.sponsorships.length > 0) {
            let message = '';
            tempJob.sponsorships.forEach((sponsor: any, key: number) => {
                if (key === tempJob.sponsorships.length - 1) {
                    message = message + sponsor;
                } else if (key === tempJob.sponsorships.length - 2) {
                    message = message + sponsor + ' and ';
                } else {
                    message = message + sponsor + ', ';
                }
            });
            tempJob.sponsorshipsDisplayMessage = message;
        }
        tempJob.profileCriteriaInfo = data.profileCriteriaInfo;
        tempJob.includeCandidatesWithNoAdditionalDetails = data.licensePreferences ? data.licensePreferences.includeCandidatesWithNoAdditionalDetails : false;
        tempJob.includeCandidatesMatchingMandatoryCriteria = data.licensePreferences ? data.licensePreferences.includeCandidatesMatchingMandatoryCriteria : false;
        return tempJob;
    }

    private _getSentAssessmentsCount(assessmentId: any, assessmentType: string, jobId: any) {
        this.jobService.getAssessmentDetails(assessmentId, jobId, (data: any) => {
            if (assessmentType === 'Technical') {
                this.sentTechnicalAssessmentsDetail = data;
            } else {
                this.sentValueAssessmentsDetail = data;
            }
        }, () => {
        });
    }

    private _getFileName(requisition: any) {
        if (requisition.jobRequisitionList[0].originalRequisitionName != null) {
            return requisition.jobRequisitionList[0].originalRequisitionName;
        } else {
            if (requisition.jobRequisitionList[0].fileName) {
                let fileName = requisition.jobRequisitionList[0].fileName;
                for (let i = 0; i < 2; i++) {
                    const index = fileName.indexOf('-');
                    fileName = fileName.substring(index + 1);
                }
                return fileName;
            } else {
                return null;
            }
        }
    }

    private _getSalaryDetailsDisplayMessage(salary: any, salaryDurationOptions: any) {
        let message = '';
        if (_.isNull(salary.salaryType)) {
            message = message + 'Not Available';
        } else if (salary.salaryType === 'SPECIFIC') {
            message = message + salary.maxSalary + ' ' + salary.currency + ' ' + this._getUOM(salary.salaryDuration, salaryDurationOptions);
        } else if (salary.salaryType === 'RANGE') {
            message = message + salary.minSalary + ' to ' + salary.maxSalary + ' ' + salary.currency + ' ' + this._getUOM(salary.salaryDuration, salaryDurationOptions);
        }
        return message;
    }

    private _getUOM(salaryDuration: any, salaryDurationOptions: any) {
        const uom: any = _.find(salaryDurationOptions, { value: salaryDuration });
        if (uom === undefined) {
            return 'Per Month';
        }
        return uom.name;
    }

    private _setEndClient(tempObj: any) {
        this.endClient = tempObj.endClient ? [tempObj.endClient] : null;
        tempObj.endClientId = tempObj.endClient ? tempObj.endClient.id : null;
    }

    private _createStepTempObject(currentStep: number) {
        switch (currentStep) {
            case 1: {
                const clientOrBUIdStepOne = !this.job.clientorbu ? null : this.job.clientorbu.id;
                this.step1DetailsTempObject = {
                    jobId: this.job.id,
                    title: this.job.title,
                    isSharedClientRequisition: this.currentJobStatus !== 'DRAFT' ? this.job.isSharedClientRequisition : this.req.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.currentJobStatus !== 'DRAFT' ? this.job.sharedClientBuOrCorpId : this.req.sharedClientBuOrCorpId,
                    clientOrBUId: clientOrBUIdStepOne,
                    requistionNumber: this.job.requisitionNumber,
                    isFutureMatchesOnly: this.isFutureMatchesOnly,
                    profileCriteriaInfo: _.cloneDeep(this.job.profileCriteriaInfo),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    tab: this.currentJobStatus !== 'DRAFT' ? 'EDIT_REQUISITION' : 'ADD_REQUISITION'
                };
                break;
            }
            case 2: {
                const clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
                this.step2DetailsTempObject = {
                    jobId: this.job.id,
                    title: this.job.title,
                    isSharedClientRequisition: this.job.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.job.sharedClientBuOrCorpId,
                    clientOrBUId,
                    requistionNumber: this.job.requisitionNumber,
                    openings: this.job.openings,
                    jobType: this.job.jobType,
                    contractDuration: this.job.contractDuration,
                    requisitionNote: this.job.requisitionNote,
                    jobSalary: _.cloneDeep(this.job.jobSalary),
                    sponsorships: this.job.sponsorships,
                    sponsorshipProvided: this.job.sponsorshipProvided,
                    workLocationIds: this.job.workLocationIds,
                    recruiters: this.job.recruiters,
                    hiringManagers: _.cloneDeep(this.job.hiringManagers),
                    pointOfContactUserId: _.cloneDeep(this.job.pointOfContactUserId),
                    vendorIds: this.job.vendorIds,
                    salary: this.job.salary,
                    tab: 'ASSIGN_RECRUITERS',
                    endClientId: this.job.endClientId
                };
                break;
            }
            case 3:
                this.workflowStepsTempObject = {
                    jobId: this.job.id,
                    score: this.job.score,
                    autoMatch: this.job.autoMatch,
                    recruiterScreening: this.job.recruiterScreening,
                    techAssessmentId: this.job.techAssessmentId,
                    techAssessmentScore: this.job.techAssessmentScore,
                    techAssessment: this.job.techAssessment,
                    valueAssessmentId: this.job.valueAssessmentId,
                    valueAssessment: this.job.valueAssessment,
                    eduVerification: this.job.eduVerification,
                    expVeification: this.job.expVeification,
                    phoneScreen: this.job.phoneScreen,
                    interview: this.job.interview,
                    imageProctoring: this.job.imageProctoring,
                    addProctoringImagesToReport: this.job.addProctoringImagesToReport,
                    workflowStepsOrder: _.cloneDeep(this.job.workflowStepsOrder),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    tab: 'WORKFLOW_STEPS'
                };
                break;
            case 4:
                this.jobBoardsSettingsTempObject = {
                    jobBoardDetails: _.cloneDeep(this.job.jobBoardDetails),
                    resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
                    isResumePullEnabled: this.job.isResumePullEnabled,
                    radius: this.job.radius,
                    recency: this.job.recency,
                    tab: 'JOB_BOARDS'
                };
                break;
            default:
                break;
        }
    }

    // ---------------------------------------------------------------------
    // Wizard navigation engine (native replacement for the jQuery/Fuel-UX
    // `.wizard()` plugin's `actionclicked`/`finished`/`changed` DOM events)
    // and step 1 (upload) save/validate logic. Steps 2-6's own navigation
    // and save/validate logic are ported in 8c-8e; until then, advancing
    // past step 1 simply moves `currentStep` forward.
    // ---------------------------------------------------------------------

    goToNextStep() {
        if (this.currentStep === 1) {
            this._advanceFromStepOne();
            return;
        }
        if (this.currentStep === 2) {
            this._advanceFromStepTwo();
            return;
        }
        if (this.currentStep === 3) {
            this._advanceFromStepThree();
            return;
        }
        if (this.currentStep === 4) {
            this._advanceFromStepFour();
            return;
        }
        if (this.currentStep === 5) {
            this._advanceFromStepFive();
            return;
        }
        this.currentStep++;
    }

    /**
     * Ported step 5/6 "Next"/"finished" handling. Our step engine only ever reaches `currentStep`
     * 5 for the final pane, whichever of "activate" (draft) or "results" (non-draft) is showing -
     * mirrors legacy's `actionclicked.fu.wizard` `case 5` (activate) and `finished.fu.wizard`
     * (results, legacy's virtual "step 6") respectively.
     */
    private _advanceFromStepFive() {
        if (this.currentJobStatus === 'DRAFT') {
            this.disableAllButtonsFlag = true;
            this._setJobStateToOpenAndRunForScoring(() => {
                const message = 'Requisition activation process has started in the background and will inform all users on the Requisition when its completed.';
                this.alertsAndNotificationsService.showAlertWithCallBack('Requisition Activation', message, 'success', () => {
                    this.$state.go('missioncontrol.requisitions');
                });
            }, () => {
                this.disableAllButtonsFlag = false;
            });
        } else {
            if (this._hasStepDataChanged(5) || this.isWorkFlowStep4Dot5ScoreChanged) {
                this.disableAllButtonsFlag = true;
                const adjustedScore = $('.slider-adjust-4dot5-score').val();
                // setting to avoid the "Unsaved data" pop up when navigating to the requisitions screen
                this.isInitialStateDraft = false;
                this.saveAdjusted4dot5Score(adjustedScore, (data: any) => {
                    this.sendOutreachEmailToCandidates(data.candidatesToMatch);
                    this.isWorkFlowStep4Dot5ScoreChanged = false;
                    this.$state.go('missioncontrol.requisitions');
                }, () => {
                    this.disableAllButtonsFlag = false;
                });
            } else {
                this.isInitialStateDraft = false;
                this.sendOutreachEmailToCandidates(this.currentScoreCandidateCounts.candidatesToMatch);
                this.$state.go('missioncontrol.requisitions');
            }
        }
        if (this.isRecalcucateScoreNoClicked) {
            this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => { });
        }
    }

    goToPreviousStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    /**
     * Explicit "Save" button handler - dispatches to the per-step save logic, mirroring the
     * legacy `wizardSaveStepData(clickedButton)` switch (which read the wizard plugin's current
     * step and gated on `_isStepDataValid`/`_hasStepDataChanged` before saving).
     */
    saveCurrentStep() {
        this._parseWorkflowStepsOrderBeforeSave();
        const currentStep = this.currentStep;
        if (!this._isStepDataValid(currentStep)) {
            return;
        }
        const stepFiveDraftActivate = currentStep === 5 && this.currentJobStatus === 'DRAFT' && this.isActivateRequisitionEnabled;
        const stepFiveResultsScoreChanged = currentStep === 5 && this.currentJobStatus !== 'DRAFT' && this.isWorkFlowStep4Dot5ScoreChanged;
        if (!(this._hasStepDataChanged(currentStep) || stepFiveDraftActivate || stepFiveResultsScoreChanged)) {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage('Nothing to be saved!', 'info');
            }
            return;
        }
        switch (currentStep) {
            case 1:
                if (this.currentJobStatus === 'DRAFT' && !this.job.id) {
                    this.createRequisitionWithoutFile(() => {
                        if (!this.editModeFlag) {
                            this.getRecruiters(() => {
                                this._setRecruitersAndHiringManagers();
                            });
                            if (!this.isCorporate) {
                                this.getPointOfContacts(() => {
                                    this._setPocs();
                                });
                            }
                            if (!this.clientOrBUIsRequiredFlag) {
                                this.getBuVendors(() => {
                                    this._setBuVendors();
                                });
                            }
                        }
                    }, () => { });
                } else if (this.currentJobStatus === 'DRAFT') {
                    this._saveStep1(false, () => { }, () => { });
                } else {
                    this.alertsAndNotificationsService.showConfirm('Recalculate Score', 'Re-calculate the scores now?', 'warning', true, () => {
                        this._saveStep1(true, () => {
                            this.isRecalcucateScoreNoClicked = false;
                        }, () => { });
                    }, () => {
                        this._saveStep1(false, () => {
                            this.isRecalcucateScoreNoClicked = true;
                        }, () => { });
                    });
                }
                break;
            case 2:
                if (this._hasRecruitersBeingUnAssigned() || this._hasVendorsBeingUnAssigned()) {
                    if (this._hasRecruitersBeingUnAssigned() && this._hasVendorsBeingUnAssigned()) {
                        const warningMessage = this._getAssignedRecruitersWarningMessage() + '<br><br>' + this._getVendorsRemovedWarningMessage();
                        this._showWarningMessage(warningMessage, () => {
                            this._saveStep2('SAVE');
                        }, () => {
                            this.job.vendorIds = _.cloneDeep(this.step2DetailsTempObject.vendorIds);
                            this._setBuVendors();
                            this.job.recruiters = _.cloneDeep(this.step2DetailsTempObject.recruiters);
                            this._setRecruitersAndHiringManagers();
                        });
                    } else if (this._hasVendorsBeingUnAssigned()) {
                        this._showVendorsRemovedWarning(() => {
                            this._saveStep2('SAVE');
                        }, () => {
                            this.job.vendorIds = _.cloneDeep(this.step2DetailsTempObject.vendorIds);
                            this._setBuVendors();
                        });
                    } else {
                        this._showRecruitersUnAssignedWarning(() => {
                            this._saveStep2('SAVE');
                        }, () => {
                            this.job.recruiters = _.cloneDeep(this.step2DetailsTempObject.recruiters);
                            this._setRecruitersAndHiringManagers();
                        });
                    }
                } else {
                    this._saveStep2('SAVE');
                }
                break;
            case 3:
                if (this.currentJobStatus === 'DRAFT') {
                    this._saveStep3('SAVE');
                } else if (this.hasMatchingMandatoryCriteriaChanged() || this.hasMissingPreferenceDetailsChanged()) {
                    this.alertsAndNotificationsService.showConfirm('Recalculate Score', 'Re-calculate the scores now?', 'warning', true, () => {
                        this._saveStep3('SAVE', true);
                    }, () => {
                        this._saveStep3('SAVE', false);
                        this.isRecalcucateScoreNoClicked = true;
                    });
                } else {
                    this._saveStep3('SAVE');
                }
                break;
            case 4:
                this._saveStep4('SAVE');
                break;
            case 5:
                if (this.currentJobStatus === 'DRAFT') {
                    this.disableAllButtonsFlag = true;
                    this._setJobStateToOpenAndRunForScoring(() => {
                        const message = 'Requisition activation process has started in the background and will inform all users on the Requisition when its completed.';
                        this.alertsAndNotificationsService.showAlertWithCallBack('Requisition Activation', message, 'success', () => {
                            this.$state.go('missioncontrol.requisitions');
                        });
                    }, () => {
                        this.disableAllButtonsFlag = false;
                    });
                } else {
                    this.disableAllButtonsFlag = true;
                    this.savingFlag = true;
                    const adjustedScore = $('.slider-adjust-4dot5-score').val();
                    this.saveAdjusted4dot5Score(adjustedScore, () => {
                        this.isWorkFlowStep4Dot5ScoreChanged = false;
                        this.disableAllButtonsFlag = false;
                        this.savingFlag = false;
                        if (this.authService.isOnline) {
                            this.alertsAndNotificationsService.showBannerMessage('The Job Match Score has been updated.', 'success');
                        }
                    }, (error: any) => {
                        this.disableAllButtonsFlag = false;
                        this.savingFlag = false;
                        if (this.authService.isOnline) {
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                    });
                }
                break;
            default:
                break;
        }
    }

    cancel() {
        if (this._hasStepDataChanged(this.currentStep)) {
            this.alertsAndNotificationsService.showConfirm(
                'Warning!', 'Unsaved data on the page will be lost. Do you still want to continue?', 'warning', true,
                () => {
                    this._resetStepData(this.currentStep, () => {
                        this.$state.go('missioncontrol.requisitions');
                    });
                    if (this.isRecalcucateScoreNoClicked) {
                        this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => { });
                    }
                },
                () => { }
            );
        } else {
            if (this.isRecalcucateScoreNoClicked) {
                this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => {
                    this.$state.go('missioncontrol.requisitions');
                });
            } else {
                this.$state.go('missioncontrol.requisitions');
            }
        }
    }

    private _advanceFromStepOne() {
        if (!this._isStepDataValid(1)) {
            this.step1Error.hasErrorFlag = true;
            this.step1Error.errorMessage = 'Please enter all mandatory fields.';
            return;
        }
        if (this._hasStepDataChanged(1)) {
            if (this.currentJobStatus === 'DRAFT' && !this.job.id) {
                this.createRequisitionWithoutFile(() => {
                    this._setDataAfterStepOneSaved();
                    this.currentStep = 2;
                }, () => { });
            } else if (this.currentJobStatus === 'DRAFT') {
                this._saveStep1(false, () => {
                    this._setDataAfterStepOneSaved();
                    this.currentStep = 2;
                }, () => { });
            } else {
                this.alertsAndNotificationsService.showConfirm('Recalculate Score', 'Re-calculate the scores now?', 'warning', true, () => {
                    this._saveStep1(true, () => {
                        this._setDataAfterStepOneSaved();
                        this.currentStep = 2;
                        this.isRecalcucateScoreNoClicked = false;
                    }, () => { });
                }, () => {
                    this._saveStep1(false, () => {
                        this._setDataAfterStepOneSaved();
                        this.currentStep = 2;
                        this.isRecalcucateScoreNoClicked = true;
                    }, () => { });
                });
            }
        } else {
            // step 1 data unchanged - advance without saving (preserves legacy
            // wizard behavior of not calling evt.preventDefault() here).
            if (this.isRecalcucateScoreNoClicked) {
                this.alertsAndNotificationsService.showConfirm('Recalculate Score', 'Re-calculate the scores now?', 'warning', true, () => {
                    this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => { });
                }, () => {
                    this.isRecalcucateScoreNoClicked = true;
                });
            }
            this.currentStep = 2;
        }
    }

    private _setDataAfterStepOneSaved() {
        this._createStepTempObject(2);
        if (!this.editModeFlag) {
            this.getRecruiters(() => {
                this._setRecruitersAndHiringManagers();
            });
            if (!this.isCorporate) {
                this.getPointOfContacts(() => {
                    this._setPocs();
                });
            }
            if (!this.clientOrBUIsRequiredFlag) {
                this.getBuVendors(() => {
                    this._setBuVendors();
                });
            }
        }
    }

    private _resetStepData(step: number, successCallback?: () => void) {
        setTimeout(() => {
            if (step === 1) {
                this.isStepOneActive = false;
                this.job.id = this.step1DetailsTempObject.jobId;
                this.job.title = this.step1DetailsTempObject.title;
                if (this.currentJobStatus !== 'DRAFT') {
                    this.job.isSharedClientRequisition = this.step1DetailsTempObject.isSharedClientRequisition;
                    this.job.sharedClientBuOrCorpId = this.step1DetailsTempObject.sharedClientBuOrCorpId;
                } else {
                    this.req.isSharedClientRequisition = this.step1DetailsTempObject.isSharedClientRequisition;
                    this.req.sharedClientBuOrCorpId = this.step1DetailsTempObject.sharedClientBuOrCorpId;
                }
                this.job.requisitionNumber = this.step1DetailsTempObject.requistionNumber;
                this.isFutureMatchesOnly = this.step1DetailsTempObject.isFutureMatchesOnly;
                this.job.profileCriteriaInfo = this.step1DetailsTempObject.profileCriteriaInfo;
                this.job.includeCandidatesWithNoAdditionalDetails = this.step1DetailsTempObject.includeCandidatesWithNoAdditionalDetails;
                this.job.includeCandidatesMatchingMandatoryCriteria = this.step1DetailsTempObject.includeCandidatesMatchingMandatoryCriteria;
            }
            if (step === 2) {
                this.isStepOneActive = false;
                this.job.title = this.step2DetailsTempObject.title;
                this.job.isSharedClientRequisition = this.step2DetailsTempObject.isSharedClientRequisition;
                this.job.sharedClientBuOrCorpId = this.step2DetailsTempObject.sharedClientBuOrCorpId;
                if (_.isNull(this.step2DetailsTempObject.clientOrBUId)) {
                    this.job.clientorbu = null;
                } else {
                    this.clientorbulist.forEach((val: any) => {
                        if (val.id === this.step2DetailsTempObject.clientOrBUId) {
                            this.job.clientorbu = val;
                        }
                    });
                }
                this.job.requisitionNumber = this.step2DetailsTempObject.requistionNumber;
                this.job.openings = this.step2DetailsTempObject.openings;
                this.job.jobType = this.step2DetailsTempObject.jobType;
                this.job.contractDuration = this.step2DetailsTempObject.contractDuration;
                this.job.requisitionNote = this.step2DetailsTempObject.requisitionNote;
                this.job.jobSalary = _.cloneDeep(this.step2DetailsTempObject.jobSalary);
                this._setJobType();
                this.job.sponsorships = this.step2DetailsTempObject.sponsorships;
                this.job.sponsorshipProvided = this.step2DetailsTempObject.sponsorshipProvided;
                this._setSponsorshipType();
                this.job.workLocationIds = this.step2DetailsTempObject.workLocationIds;
                this._setWorkLocations();
                this.job.recruiters = this.step2DetailsTempObject.recruiters;
                this.job.hiringManagers = _.cloneDeep(this.step2DetailsTempObject.hiringManagers);
                this.job.vendorIds = this.step2DetailsTempObject.vendorIds;
                this.job.salary = this.step2DetailsTempObject.salary;
                this._setRecruitersAndHiringManagers();
                this._setBuVendors();
            }
            if (step === 3) {
                this.job.score = this.workflowStepsTempObject.score;
                $('.slider-intelligence').val(this.job.score);
                $('#4dot5IntelligenceScoreDisplayValue').text(this.job.score);
                this.job.autoMatch = this.workflowStepsTempObject.autoMatch;
                this.job.recruiterScreening = this.workflowStepsTempObject.recruiterScreening;
                this.job.techAssessmentId = this.workflowStepsTempObject.techAssessmentId;
                this.job.techAssessment = this.workflowStepsTempObject.techAssessment;
                this.job.techAssessmentScore = this.workflowStepsTempObject.techAssessmentScore;
                $('.slider-tech-assessment').val(this.job.techAssessmentScore);
                $('#techAssessmentScoreDisplayValue').text(this.job.techAssessmentScore);
                this.job.valueAssessment = this.workflowStepsTempObject.valueAssessment;
                this.job.techAssessmentScore = this.workflowStepsTempObject.techAssessmentScore;
                this.job.valueAssessmentId = this.workflowStepsTempObject.valueAssessmentId;
                this.job.eduVerification = this.workflowStepsTempObject.eduVerification;
                this.job.expVeification = this.workflowStepsTempObject.expVeification;
                this.job.phoneScreen = this.workflowStepsTempObject.phoneScreen;
                this.job.interview = this.workflowStepsTempObject.interview;
                this.job.imageProctoring = this.workflowStepsTempObject.imageProctoring;
                this.job.addProctoringImagesToReport = this.workflowStepsTempObject.addProctoringImagesToReport;
                this.job.workflowStepsOrder = _.cloneDeep(this.workflowStepsTempObject.workflowStepsOrder);
                this.job.includeCandidatesWithNoAdditionalDetails = this.workflowStepsTempObject.includeCandidatesWithNoAdditionalDetails;
                this.job.includeCandidatesMatchingMandatoryCriteria = this.workflowStepsTempObject.includeCandidatesMatchingMandatoryCriteria;
            }
            if (step === 4) {
                this.job.jobBoardDetails = _.cloneDeep(this.jobBoardDetailsCopy);
                this.job.resumesToPullPerJobBoardCount = this.jobBoardsSettingsTempObject.resumesToPullPerJobBoardCount;
                this.job.isResumePullEnabled = this.jobBoardsSettingsTempObject.isResumePullEnabled;
                this.job.radius = this.jobBoardsSettingsTempObject.radius;
                this.job.recency = this.jobBoardsSettingsTempObject.recency;
            }
            if (step === 5) {
                // Ported from legacy case 5 (activate) - do nothing.
                // Ported from legacy case 6 (results) - only relevant when the results pane is showing.
                if (this.currentJobStatus !== 'DRAFT') {
                    $('.slider-adjust-4dot5-score').val(this.job.score);
                    $('#adjust4dot5ScoreDisplayValue').text(this.job.score);
                    this.getCandidateCount(this.job.score, 'adjustedScore');
                }
            }
            if (successCallback) {
                successCallback();
            }
        });
    }

    private _isStepDataValid(currentStep: number): boolean {
        let stepDataValidityFlag = true;
        switch (currentStep) {
            case 1: {
                if (this.forms && this.forms.step1Form) {
                    this.forms.step1Form.$submitted = true;
                }
                if (this.req.clientOrBU && this.req.clientOrBU.id &&
                    ((this.currentJobStatus === 'DRAFT' && (this.job.title && this.job.title !== '')) || this.currentJobStatus !== 'DRAFT')) {
                    if (this.req.clientOrBU.companyType === 'Corporation') {
                        if (this.sharedClientBuOrCorp && this.sharedClientBuOrCorp.id) {
                            stepDataValidityFlag = true;
                            this.step1Error.hasErrorFlag = false;
                            this.step1Error.errorMessage = '';
                        } else {
                            stepDataValidityFlag = false;
                            this.step1Error.hasErrorFlag = true;
                            this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                        }
                    } else {
                        stepDataValidityFlag = true;
                        this.step1Error.hasErrorFlag = false;
                        this.step1Error.errorMessage = '';
                    }
                } else if (this.isCorporate && (this.currentJobStatus !== 'DRAFT' || (this.currentJobStatus === 'DRAFT' && (this.job.title && this.job.title !== '')))) {
                    stepDataValidityFlag = true;
                    this.step1Error.hasErrorFlag = false;
                    this.step1Error.errorMessage = '';
                } else {
                    stepDataValidityFlag = false;
                    this.step1Error.hasErrorFlag = true;
                    this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                }
                break;
            }
            case 2: {
                this.step2Submitted = true;
                if (!this.step2RequiredFieldsValid || (this.job.jobType == null) || (this.job.recruiters.length === 0) ||
                    (this.job.sponsorshipProvided && this.job.sponsorships.length === 0) || (this.job.workLocationIds.length === 0) ||
                    (this.job.hiringManagers.length > 0 && !this.isPrimaryHiringManagerSelected()) ||
                    (this.job.vendorIds.length > 0 && _.isNull(this.job.pointOfContactUserId))) {
                    this.step2Error.hasErrorFlag = true;
                    this.step2Error.errorMessage = 'Please enter all mandatory fields.';
                    stepDataValidityFlag = false;
                } else {
                    this.step2Error.hasErrorFlag = false;
                    this.step2Error.errorMessage = '';
                }
                break;
            }
            case 3: {
                this.step3Submitted = true;
                if (!this.step3RequiredFieldsValid) {
                    this.step3Error.hasErrorFlag = true;
                    this.step3Error.errorMessage = 'Please enter all mandatory fields.';
                    stepDataValidityFlag = false;
                } else {
                    this.step3Error.hasErrorFlag = false;
                    this.step3Error.errorMessage = '';
                }
                break;
            }
            case 4:
                break;
            case 5:
                // Ported from legacy case 5 (activate)/case 6 (results) - both do nothing, always valid.
                break;
            default:
                break;
        }
        return stepDataValidityFlag;
    }

    private _hasStepDataChanged(currentStep: number): boolean {
        let stepDataHasChangedFlag = false;
        switch (currentStep) {
            case 1: {
                const clientOrBUIdStepOne = !this.job.clientorbu ? null : this.job.clientorbu.id;
                const currentStep1DataObject: any = {
                    jobId: this.job.id,
                    title: this.job.title,
                    isSharedClientRequisition: this.currentJobStatus !== 'DRAFT' ? this.job.isSharedClientRequisition : this.req.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.currentJobStatus !== 'DRAFT' ? this.job.sharedClientBuOrCorpId : this.req.sharedClientBuOrCorpId,
                    clientOrBUId: clientOrBUIdStepOne,
                    requistionNumber: this.job.requisitionNumber,
                    isFutureMatchesOnly: this.isFutureMatchesOnly,
                    profileCriteriaInfo: _.cloneDeep(this.job.profileCriteriaInfo),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    tab: this.currentJobStatus !== 'DRAFT' ? 'EDIT_REQUISITION' : 'ADD_REQUISITION'
                };
                const step1DetailsTempObject: any = _.cloneDeep(this.step1DetailsTempObject);
                this._removeUnusedSkills(step1DetailsTempObject.profileCriteriaInfo);
                this._removeUnusedSkills(currentStep1DataObject.profileCriteriaInfo);
                currentStep1DataObject.profileCriteriaInfo = this._setProfileCriteria(step1DetailsTempObject.profileCriteriaInfo, currentStep1DataObject.profileCriteriaInfo);
                this.isSkillsChanged = !_.isEqual(step1DetailsTempObject.profileCriteriaInfo, currentStep1DataObject.profileCriteriaInfo);
                stepDataHasChangedFlag = !_.isEqual(step1DetailsTempObject, currentStep1DataObject);
                break;
            }
            case 2: {
                const clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
                const currentStep2DataObject: any = {
                    jobId: this.job.id,
                    isSharedClientRequisition: this.job.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.job.sharedClientBuOrCorpId,
                    clientOrBUId,
                    requistionNumber: this.job.requisitionNumber,
                    openings: this.job.openings,
                    title: this.job.title,
                    jobType: this.job.jobType,
                    contractDuration: this.job.contractDuration,
                    requisitionNote: this.job.requisitionNote,
                    jobSalary: _.cloneDeep(this.job.jobSalary),
                    sponsorships: this.job.sponsorships,
                    sponsorshipProvided: this.job.sponsorshipProvided,
                    workLocationIds: this.job.workLocationIds,
                    recruiters: this.job.recruiters,
                    hiringManagers: _.cloneDeep(this.job.hiringManagers),
                    vendorIds: this.job.vendorIds,
                    pointOfContactUserId: this.job.pointOfContactUserId,
                    salary: this.job.salary,
                    tab: 'ASSIGN_RECRUITERS',
                    endClientId: this.job.endClientId
                };
                stepDataHasChangedFlag = !_.isEqual(this.step2DetailsTempObject, currentStep2DataObject);
                if (!this.hasClientOrBuChanged) {
                    this.hasClientOrBuChanged = !_.isEqual(this.step2DetailsTempObject.clientOrBUId, currentStep2DataObject.clientOrBUId);
                }
                if (this.hasClientOrBuChanged || this.isJobLocationChanged) {
                    stepDataHasChangedFlag = true;
                }
                if (!_.isEqual(this.step2DetailsTempObject.workLocationIds, currentStep2DataObject.workLocationIds) ||
                    !_.isEqual(this.step2DetailsTempObject.sponsorships, currentStep2DataObject.sponsorships) || this.isJobLocationChanged) {
                    this.isAsyncProcess = true;
                }
                break;
            }
            case 3: {
                const currentWorkflowStepsObject: any = {
                    jobId: this.job.id,
                    score: this.job.score,
                    autoMatch: this.job.autoMatch,
                    recruiterScreening: this.job.recruiterScreening,
                    techAssessmentId: this.job.techAssessmentId,
                    techAssessmentScore: this.job.techAssessmentScore,
                    techAssessment: this.job.techAssessment,
                    valueAssessmentId: this.job.valueAssessmentId,
                    valueAssessment: this.job.valueAssessment,
                    eduVerification: this.job.eduVerification,
                    expVeification: this.job.expVeification,
                    phoneScreen: this.job.phoneScreen,
                    interview: this.job.interview,
                    imageProctoring: this.job.imageProctoring,
                    addProctoringImagesToReport: this.job.addProctoringImagesToReport,
                    workflowStepsOrder: _.cloneDeep(this.job.workflowStepsOrder),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    tab: 'WORKFLOW_STEPS'
                };
                stepDataHasChangedFlag = !_.isEqual(this.workflowStepsTempObject, currentWorkflowStepsObject) || !this.isLicensePreferenceSet;
                break;
            }
            case 4: {
                const currentJobBoardsSettingsObject: any = {
                    jobBoardDetails: _.cloneDeep(this.job.jobBoardDetails),
                    resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
                    isResumePullEnabled: this.job.isResumePullEnabled,
                    radius: this.job.radius,
                    recency: this.job.recency,
                    tab: 'JOB_BOARDS'
                };
                stepDataHasChangedFlag = !_.isEqual(this.jobBoardsSettingsTempObject, currentJobBoardsSettingsObject) || this.job.isResumePullEnabled;
                if (!this.isJobBoardDetailsSet) {
                    stepDataHasChangedFlag = true;
                }
                break;
            }
            case 5:
                // Ported from legacy case 5 (activate pane, `currentJobStatus === 'DRAFT'`) - do nothing, always unchanged.
                // and legacy case 6 (results pane, `currentJobStatus !== 'DRAFT'`) - our step engine reaches `currentStep`
                // 5 for both mutually-exclusive panes (only one of which ever renders), so branch on currentJobStatus here.
                if (this.currentJobStatus !== 'DRAFT') {
                    const adjustedScore = $('.slider-adjust-4dot5-score').val();
                    if (this.isInitialStateDraft || adjustedScore != this.job.score) {
                        stepDataHasChangedFlag = true;
                    }
                }
                break;
            default:
                break;
        }
        return stepDataHasChangedFlag;
    }

    private _removeUnusedSkills(skills: any) {
        if (!skills) {
            return;
        }
        const skillsArray = ['educations', 'experiences', 'technicalSkills', 'operationalSkills', 'softSkills', 'otherSkills', 'certifications'];
        skillsArray.forEach((skill) => {
            if (skills[skill]) {
                skills[skill] = skills[skill]
                    .filter((item: any) => item.displayName && item.displayName.trim() !== '')
                    .map((item: any) => ({
                        ...item,
                        range: !item.range ? '' : (item.displayName && item.displayName.includes(item.range)) ? item.range : '',
                        plusTo: !item.plusTo ? '' : item.plusTo
                    }));
            } else {
                skills[skill] = [];
            }
        });
    }

    private _setProfileCriteria(obj1: any, obj2: any) {
        const newObj: any = {};
        const keys = Object.keys(obj1 || {});
        keys.forEach((key) => {
            const val1 = obj1[key];
            const val2 = obj2[key];
            if (Array.isArray(val1) && Array.isArray(val2)) {
                if (val1.length !== val2.length) {
                    newObj[key] = val2;
                } else {
                    newObj[key] = val1.map((item: any, index: number) => {
                        const newItem: any = {};
                        const item2 = val2[index] || {};
                        Object.keys(item).forEach((subKey) => {
                            newItem[subKey] = item2[subKey];
                        });
                        return newItem;
                    });
                }
            } else if (!val1) {
                newObj[key] = val2;
            } else if (!val2) {
                newObj[key] = [];
            } else {
                newObj[key] = val2;
            }
        });
        return newObj;
    }

    private _setProfileCriteriaInfoSkills(profileCriteriaInfo: any) {
        const categorizeSkills = (skills: any[], skillType: string) => {
            if (skills && skills.length > 0) {
                return skills
                    .filter((skill) => skill.displayName && skill.displayName.trim() !== '')
                    .map((skill) => ({ ...skill, skillType }));
            }
            return [];
        };
        profileCriteriaInfo.technicalSkills = categorizeSkills(profileCriteriaInfo.technicalSkills, 'TECHNICALSKILLS');
        profileCriteriaInfo.operationalSkills = categorizeSkills(profileCriteriaInfo.operationalSkills, 'OPERATIONALSKILLS');
        profileCriteriaInfo.otherSkills = categorizeSkills(profileCriteriaInfo.otherSkills, 'OTHERS');
        profileCriteriaInfo.softSkills = categorizeSkills(profileCriteriaInfo.softSkills, 'SOFTSKILLS');
        ['educations', 'experiences', 'certifications'].forEach((key) => {
            profileCriteriaInfo[key] = (profileCriteriaInfo[key] || [])
                .filter((item: any) => item.displayName && item.displayName.trim() !== '');
        });
    }

    private _checkIfFlagsChanged(currentStep1TempObject: any, step1DetailsTempObject: any) {
        return (step1DetailsTempObject.includeCandidatesWithNoAdditionalDetails !== currentStep1TempObject.includeCandidatesWithNoAdditionalDetails) ||
            (step1DetailsTempObject.includeCandidatesMatchingMandatoryCriteria !== currentStep1TempObject.includeCandidatesMatchingMandatoryCriteria);
    }

    private reRunResumeScore(message: string, successCallback: () => void) {
        const requestObject: any = new RunCandidateScore(this.companyId, this.userId);
        requestObject.jobId = this.job.id;
        requestObject.rerunType = 'REQUISITION';
        requestObject.source = 'EDITREQ';
        this.resumeService.reRunResumeScore(requestObject, (data: any) => {
            this.alertsAndNotificationsService.showAlertWithCallBack('Candidate scoring in Progress', message ? message : data.message, 'success', () => {
                this.isRecalcucateScoreNoClicked = false;
                if (successCallback) {
                    successCallback();
                }
            });
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    private updateUserCache() {
        this.userService.userCache(null, () => { }, () => { });
    }

    private _saveStep1(isRerun: boolean, successCallback: () => void, errorCallback: () => void) {
        this.disableAllButtonsFlag = true;
        this.savingFlag = true;
        this.requisitionSkillsLoading = true;
        this._saveStep1Details(isRerun, () => {
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            this.requisitionSkillsLoading = false;
            this._createStepTempObject(1);
            this.isSkillsChanged = false;
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            this.requisitionSkillsLoading = false;
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    }

    private _saveStep1Details(isRerun: boolean, successCallback: () => void, errorCallback: (error: any) => void) {
        const clientOrBUIdStepOne = !this.job.clientorbu ? null : this.job.clientorbu.id;
        this.job.profileCriteriaInfo.title = this.job.title;
        this._setProfileCriteriaInfoSkills(this.job.profileCriteriaInfo);
        const step1DetailsTempObject: any = {
            jobId: this.job.id,
            title: this.job.title,
            isSharedClientRequisition: this.currentJobStatus !== 'DRAFT' ? this.job.isSharedClientRequisition : this.req.isSharedClientRequisition,
            sharedClientBuOrCorpId: this.currentJobStatus !== 'DRAFT' ? this.job.sharedClientBuOrCorpId : this.req.sharedClientBuOrCorpId,
            clientOrBUId: clientOrBUIdStepOne,
            requistionNumber: this.job.requisitionNumber,
            isFutureMatchesOnly: this.isFutureMatchesOnly,
            profileCriteriaInfo: this.job.profileCriteriaInfo,
            source: this.currentJobStatus !== 'DRAFT' ? 'EDITREQ' : 'CREATEREQ',
            tab: this.currentJobStatus !== 'DRAFT' ? 'EDIT_REQUISITION' : 'ADD_REQUISITION'
        };
        step1DetailsTempObject.profileCriteriaInfo.userEnteredDescription = true;
        let updateFlag = true;
        const companyId = (this.job && this.job.company && this.job.company.id) ? this.job.company.id : this.userDetails.company.companyId;
        this.utilityService.showLoadingModal('Saving...');
        step1DetailsTempObject.rerunScore = isRerun;
        step1DetailsTempObject.recalculateLater = !isRerun;
        if (this.currentJobStatus !== 'DRAFT') {
            step1DetailsTempObject.includeCandidatesWithNoAdditionalDetails = this.job.includeCandidatesWithNoAdditionalDetails;
            step1DetailsTempObject.includeCandidatesMatchingMandatoryCriteria = this.job.includeCandidatesMatchingMandatoryCriteria;
            step1DetailsTempObject.asyncActionType = 'async';
            step1DetailsTempObject.criteriaUpdated = this.isSkillsChanged;
            step1DetailsTempObject.flagsUpdated = this._checkIfFlagsChanged(step1DetailsTempObject, this.step1DetailsTempObject);
            this.jobService.createUpdateJobDetails(updateFlag, step1DetailsTempObject, companyId, clientOrBUIdStepOne, this.userDetails.id, (data: any) => {
                this.job.profileCriteriaInfo = (data && data.t) ? { ...data.t.profileCriteriaInfo } : this.job.profileCriteriaInfo;
                this.job.title = (data && data.t) ? data.t.title : this.job.title;
                this.updateUserCache();
                this.utilityService.hideLoadingModal();
                if (data && !data.t && data.message) {
                    const title = (!step1DetailsTempObject.rerunScore && step1DetailsTempObject.recalculateLater) ? 'Job updated successfully.' : 'Job matching in Progress';
                    this.alertsAndNotificationsService.showAlertWithCallBack(title, data.message, 'success', () => {
                        if (step1DetailsTempObject.rerunScore && !step1DetailsTempObject.recalculateLater) {
                            this.$state.go('missioncontrol.requisitions');
                        }
                    });
                }
                this._createStepTempObject(1);
                if (successCallback) {
                    successCallback();
                }
            }, (error: any) => {
                if (errorCallback) {
                    errorCallback(error);
                }
                this.utilityService.hideLoadingModal();
            });
        } else {
            updateFlag = false;
            const clientOrBUId = this.req.clientOrBU ? this.req.clientOrBU.id : null;
            this.jobService.createUpdateJobDetails(updateFlag, step1DetailsTempObject, companyId, clientOrBUId, this.userDetails.id, (data: any) => {
                this.job.profileCriteriaInfo = (data && data.t) ? { ...data.t.profileCriteriaInfo } : this.job.profileCriteriaInfo;
                this.job.title = (data && data.t) ? data.t.title : this.job.title;
                this._createStepTempObject(1);
                if (successCallback) {
                    successCallback();
                }
                this.updateUserCache();
                this.utilityService.hideLoadingModal();
            }, (error: any) => {
                if (errorCallback) {
                    errorCallback(error);
                }
                this.utilityService.hideLoadingModal();
            });
        }
    }

    createRequisitionWithoutFile(successCallback: () => void, errorCallback: () => void) {
        const clientOrBUIdStepOne = this.req.clientOrBU ? this.req.clientOrBU.id : '';
        this._setProfileCriteriaInfoSkills(this.job.profileCriteriaInfo);
        const step1DetailsTempObject: any = { ...this.job.profileCriteriaInfo };
        step1DetailsTempObject.title = this.job.title;
        if (this.job.location && this.job.location.city) {
            step1DetailsTempObject.location = { ...this.job.location };
            step1DetailsTempObject.location.city = { name: this.job.location.city };
        }
        step1DetailsTempObject.sharedClientBuOrCorpId = this.req.sharedClientBuOrCorpId;
        step1DetailsTempObject.isSharedClientRequisition = this.req.isSharedClientRequisition;
        step1DetailsTempObject.userEnteredDescription = true;

        const companyId = this.userDetails.company.companyId;
        this.utilityService.showLoadingModal('Saving...');
        this.requisitionSkillsLoading = true;
        step1DetailsTempObject.source = 'CREATEREQ';

        this.jobService.createJobDescription(step1DetailsTempObject, companyId, clientOrBUIdStepOne, this.userDetails.id, (data: any) => {
            this.job = this._parseJobResponse(data);
            this._setSponsorshipSelectedDefault(false);
            this._createStepTempObject(1);
            this._createStepTempObject(2);
            this.getAllJobBoards(() => {
                this._setJobBoardDetails();
            });
            this.updateActionButtons();
            this.isEditRequisitionDetails = true;
            this.isUploadRequisition = false;
            this.isUploadAndEditRadioBtn = false;
            this.requisitionSkillsLoading = false;
            this.isClientOrBuDisabled = true;
            this.updateUserCache();
            this.utilityService.hideLoadingModal();
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            this.requisitionSkillsLoading = false;
            this.utilityService.hideLoadingModal();
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (errorCallback) {
                errorCallback();
            }
        });
    }

    updateActionButtons() {
        switch (this.currentStep) {
            case 1: {
                this.isStepOneActive = true;
                this.isClientOrBuRequired = false;
                if (this.clientOrBUIsRequiredFlag) {
                    if (this.req.clientOrBU && angular.isDefined(this.req.clientOrBU) && angular.isDefined(this.req.clientOrBU.id) && this.fileExistsFlag &&
                        ((!_.isNull(this.job)) && (_.isNull(this.job.id))) &&
                        (this.req.clientOrBU.companyType !== 'Corporation' || (this.req.clientOrBU.companyType === 'Corporation' && !_.isNull(this.req.sharedClientBuOrCorpId)))) {
                        this.disableUploadButtonFlag = false;
                    } else if (this.fileExistsFlag && (!this.req.clientOrBU || !this.req.clientOrBU.id)) {
                        this.isClientOrBuRequired = true;
                        this.disableUploadButtonFlag = true;
                    } else {
                        if (this.req.clientOrBU && this.req.clientOrBU.id) {
                            this.disableNextButtonFlag = false;
                        }
                        this.disableUploadButtonFlag = true;
                    }
                } else {
                    if ((this.req.clientOrBU || this._isAssociatedBuSelected()) && (this.fileExistsFlag && ((!_.isNull(this.job)) && (_.isNull(this.job.id))))) {
                        this.disableUploadButtonFlag = false;
                    } else if (!this.req.clientOrBU && this.clientorbulist.filter((clientOrBu: any) => clientOrBu.id === '').length === 0) {
                        this.isClientOrBuRequired = true;
                        this.disableUploadButtonFlag = true;
                    } else {
                        this.disableUploadButtonFlag = true;
                    }
                }

                if (angular.isDefined(this.job.id) && this.job.id != null) {
                    this.disableNextButtonFlag = false;
                    this.disableSaveButtonFlag = false;
                } else {
                    if ((!this.isUploadRequisition && (this.isCorporate || (this.req.clientOrBU && this.req.clientOrBU.id)))) {
                        this.disableNextButtonFlag = false;
                    } else {
                        this.disableNextButtonFlag = true;
                    }
                }
                break;
            }
            case 2:
                this.isStepOneActive = false;
                this.disableSaveButtonFlag = false;
                break;
            case 3:
                this.disableSaveButtonFlag = false;
                break;
            case 5:
                // Ported from legacy `case 6` (results pane, `currentJobStatus !== 'DRAFT'`) - the
                // legacy `case 5` (activate pane) has no entry in this switch at all.
                if (this.currentJobStatus !== 'DRAFT') {
                    this.disableSaveButtonFlag = false;
                }
                break;
            default:
                break;
        }
        setTimeout(() => this.cdr.detectChanges(), 200);
    }

    private _isAssociatedBuSelected() {
        return !this.req.clientOrBU && this.clientorbulist.filter((clientOrBu: any) => clientOrBu.id === '').length > 0;
    }

    /**
     * Process the file queue in the drop zone and upload the requisition
     */
    uploadRequisition() {
        this.uploadReqStepUpload.reqUploadDropzoneDirective.dropzone().processQueue();
    }

    onUploadDropzoneReady() {
        this.reqUploadDropzone = this.uploadReqStepUpload.reqUploadDropzoneDirective.dropzone();
        if (this._pendingDropzoneFile) {
            this._setFileInUploadDropZone(this._pendingDropzoneFile.fileName, this._pendingDropzoneFile.fileSize);
            this._pendingDropzoneFile = null;
        }
    }

    /** Ported from legacy `updateRequisitionDetails()` - step 1's upload-vs-manual-entry radio toggle callback. */
    updateRequisitionDetails() {
        if (!this.isUploadRequisition) {
            this.disableSaveButtonFlag = false;
            this.disableNextButtonFlag = !(this.isCorporate || (this.req.clientOrBU && this.req.clientOrBU.id));
            if (this.step1Error.hasErrorFlag) {
                this.step1Error.errorMessage = 'Please enter all mandatory fields.';
            }
        } else {
            this.disableSaveButtonFlag = true;
            this.disableNextButtonFlag = true;
            if (this.step1Error.hasErrorFlag) {
                this.step1Error.errorMessage = '';
            }
        }
    }

    onReqUploadFileAdded() {
        this.fileExistsFlag = true;
        this.updateActionButtons();
        $('.dz-progress').css({ top: '70%' });
    }

    onReqUploadFileRemoved() {
        // Destroying the dropzone after a successful upload also emits removedFile, mid change detection.
        if (!this.isUploadRequisition) {
            return;
        }
        this.fileExistsFlag = false;
        this.isClientOrBuDisabled = false;
        this.job = new Job();
        this.updateActionButtons();
        this.isEditRequisitionDetails = false;
    }

    onReqUploadFileSending(args: any) {
        const formData = args[2];
        this.disableUploadButtonFlag = true;
        this.isClientOrBuDisabled = true;
        this.fileUploadInProgressFlag = true;
        formData.append('companyId', this.userDetails.company.companyId);
        formData.append('isSharedClientRequisition', this.req.isSharedClientRequisition);
        if (this.req.clientOrBU) {
            formData.append('buId', this.req.clientOrBU.id);
        }
        if (this.req.sharedClientBuOrCorpId !== null) {
            formData.append('sharedClientBuOrCorpId', this.req.sharedClientBuOrCorpId);
        }
        formData.append('userId', this.userDetails.id);
    }

    onReqUploadFileSuccess(args: any) {
        const response = args[1];
        this.fileUploadInProgressFlag = false;
        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.UPLOAD.UPLOAD_SUCCESS, 'success');
        this.job = this._parseJobResponse(response);
        this._setSponsorshipSelectedDefault(false);
        this._createStepTempObject(1);
        this._createStepTempObject(2);
        this.getAllJobBoards(() => {
            this._setJobBoardDetails();
        });
        if (!this.editModeFlag) {
            this.getRecruiters(() => {
                this._setRecruitersAndHiringManagers();
            });
            if (!this.isCorporate) {
                this.getPointOfContacts(() => {
                    this._setPocs();
                });
            }
            if (!this.clientOrBUIsRequiredFlag) {
                this.getBuVendors(() => {
                    this._setBuVendors();
                });
            }
        }
        this.updateActionButtons();
        this.isEditRequisitionDetails = true;
        this.isUploadRequisition = false;
        this.isUploadAndEditRadioBtn = false;
    }

    onReqUploadFileError(args: any) {
        const file = args[0];
        const error = args[1];
        const elements = document.querySelectorAll('.dz-file-preview');
        elements.forEach((element: any) => {
            const filename = element.querySelectorAll('.dz-filename span')[0].textContent;
            const errorMessage = element.querySelectorAll('.dz-error-message span')[0];
            if (filename === file.name) {
                errorMessage.textContent = error.message === undefined ? error : error.message;
            }
        });
    }

    private _setFileInUploadDropZone(fileName: string, fileSize: number) {
        if (!this.reqUploadDropzone || !this.reqUploadDropzone.options) {
            // the upload-req-step-upload component hasn't finished constructing the
            // dropzone yet - apply this once onUploadDropzoneReady() runs.
            this._pendingDropzoneFile = { fileName, fileSize };
            return;
        }
        const mockFile = { name: fileName, size: fileSize };
        this.reqUploadDropzone.options.addedfile.call(this.reqUploadDropzone, mockFile);
        // delete the remove-button/progress-bar DOM for the file in the drop zone since the job is now in 'open' status
        $('.dz-remove').remove();
        $('.dz-progress').remove();
        $('.dz-file-preview.dz-preview').addClass('dz-success');
    }

    // ---------------------------------------------------------------------
    // Stubs for logic owned by later sub-steps of build step 8 (wizard
    // engine + per-step save/validate, ported in 8b-8e). These exist only
    // so ngOnInit's control flow runs without runtime errors; each is
    // implemented for real in the step noted below.
    // ---------------------------------------------------------------------

    /** No-op: the native step engine (`currentStep`) needs no lazy plugin init, unlike the jQuery/Fuel-UX `.wizard()` it replaces. */
    private _ensureWizardInitialized() { }


    // ---------------------------------------------------------------------
    // Step 2 (recruiters/general info) - client/BU, job type, salary, work
    // location, sponsorship, recruiters/hiring managers/POCs/vendors
    // selection, end client, and step 2 save/validate. Ported in step 8c.
    // ---------------------------------------------------------------------

    getAllClientsOrBu(successCallback?: () => void) {
        const requisitionId = _.isNull(this.job.id) ? null : this.job.id;
        const isFromCreateReq = !requisitionId;
        this.requisitionService.getAllClientsOrBu(this.userDetails, requisitionId, isFromCreateReq, (data: any) => {
            this.clientorbulist = data;
            this.clientorbulist.forEach((clientOrBu: any) => {
                clientOrBu.displayName = clientOrBu.companyType === 'Corporation' ? clientOrBu.name + ' 🔗' : clientOrBu.name;
            });
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    private _setClientOrBu(clientorbu: any) {
        if (!_.isNull(clientorbu)) {
            this.req.clientOrBU = {
                name: clientorbu.name,
                companyType: clientorbu.companyType,
                companyState: clientorbu.companyState,
                id: clientorbu.id,
                shortName: clientorbu.shortName
            };
        } else {
            this.req.clientOrBU = null;
        }
    }

    /** Ported from the legacy `onClientChange()` - step 1's client/BU selection callback. */
    onClientChange() {
        const clientOrBusWithoutNoAssociatedBus = this.clientorbulist.filter((clientOrBu: any) => clientOrBu.id !== '');
        const clientOrBUId = !this.req.clientOrBU ? '' : this.req.clientOrBU.id;
        const selectedClientOrBu = _.find(clientOrBusWithoutNoAssociatedBus, { id: clientOrBUId });
        this.req.clientOrBU = _.cloneDeep(selectedClientOrBu);
        if (this.req.clientOrBU && this.req.clientOrBU.companyType === 'Corporation') {
            this.req.isSharedClientRequisition = true;
            this._getSharedClientBus();
        } else {
            this.req.isSharedClientRequisition = false;
            this.req.sharedClientBuOrCorpId = null;
            this.sharedCorporateId = null;
        }
        this.updateActionButtons();
        this._validateStepOne();
    }

    onClientOrBuChanged() {
        const clientOrBusWithoutNoAssociatedBus = this.clientorbulist.filter((clientOrBu: any) => clientOrBu.id !== '');
        const selectedClientOrBu = _.find(clientOrBusWithoutNoAssociatedBus, { id: this.job.clientorbu.id });
        this.job.clientorbu = _.cloneDeep(selectedClientOrBu);
        this.req.clientOrBU = _.cloneDeep(selectedClientOrBu);
        this.editBUFlag = !this.editBUFlag;
        this.job.recruiters = [];
        this.job.hiringManagers = [];
        this.job.vendorIds = [];
        this.job.pointOfContactUserId = null;
        this.getRecruiters(() => {
            this._setRecruitersAndHiringManagers();
        });
        if (!this.clientOrBUIsRequiredFlag) {
            this.getBuVendors(() => {
                this._setBuVendors();
            });
        }
        if (this.job.clientorbu && this.job.clientorbu.companyType === 'Corporation') {
            this.req.isSharedClientRequisition = true;
            this.job.isSharedClientRequisition = true;
            this._getSharedClientBus();
        } else {
            this.req.isSharedClientRequisition = false;
            this.job.isSharedClientRequisition = false;
            this.req.sharedClientBuOrCorpId = null;
            this.job.sharedClientBuOrCorpId = null;
            this.sharedCorporateId = null;
            this.sharedClientBuOrCorp = {};
        }
        this.getAllJobBoards(() => {
            this._setJobBoardDetails();
        });
    }

    private _getSharedClientBus(successCallback?: () => void) {
        this.isLoadingSharedClientBus = true;
        this.companyService.getSharedClientBus(this.companyId, this.req.clientOrBU.id, (data: any) => {
            this.sharedClientBus = data;
            if (this.req.clientOrBU && this.req.clientOrBU.companyType === 'Corporation') {
                const sharedClient: any = _.cloneDeep(this.req.clientOrBU);
                sharedClient.name = 'None';
                sharedClient.companyType = 'Corporation';
                this.sharedClientBus.push(sharedClient);
                this._setSharedClientBu();
            }
            this.isLoadingSharedClientBus = false;
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    private _setSharedClientBu() {
        this.sharedClientBuOrCorp = _.find(this.sharedClientBus, { id: this.req.sharedClientBuOrCorpId });
        if (this.req.clientOrBU) {
            this.sharedCorporateId = this.req.clientOrBU.companyType === 'Corporation' ? this.req.clientOrBU.id : null;
        }
    }

    /** Ported from the legacy `onSharedClientChanged(tabNumber)`; step 2's template always calls it with tabNumber 2. */
    onSharedClientChanged(_tabNumber: number = 2) {
        this.sharedCorporateId = this.req.clientOrBU.id;
        this.req.sharedClientBuOrCorpId = this.sharedClientBuOrCorp.id;
        this.job.sharedClientBuOrCorpId = this.sharedClientBuOrCorp.id;
        this.getPointOfContacts(() => {
            this._setPocs();
        });
        this.updateActionButtons();
        // Preserved pre-existing legacy behavior: `onSharedClientChanged` always calls
        // `validateStepOne()` regardless of which step's shared-client-bu selector triggered it.
        this._validateStepOne();
    }

    /** Ported from legacy `validateStepOne()` (used only by `onSharedClientChanged`, per its pre-existing behavior above). */
    private _validateStepOne() {
        setTimeout(() => {
            if (this.forms && this.forms.step1Form && this.forms.step1Form.$submitted) {
                if (!this.req.clientOrBU || !this.sharedClientBuOrCorp) {
                    this.step1Error.hasErrorFlag = true;
                    this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                } else {
                    this.step1Error.hasErrorFlag = false;
                    this.step1Error.errorMessage = '';
                }
            }
        }, 100);
    }

    getPointOfContacts(successCallback?: () => void) {
        const clientOrBu = this.job.clientorbu || this.req.clientOrBU;
        const isShared = this.job.isSharedClientRequisition || this.req.isSharedClientRequisition;
        let clientOrBUId = isShared ? this.job.sharedClientBuOrCorpId : clientOrBu.id;
        const corporateId = this.sharedCorporateId;
        if (corporateId === clientOrBUId) {
            clientOrBUId = null;
        }
        this.companyService.getClientOrBuPocs(corporateId, clientOrBUId, (data: any) => {
            this.pocs = data;
            this.pocs.forEach((poc: any) => {
                poc.userId = poc.id;
            });
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    private _setPocs() {
        this.pocs.forEach((poc: any) => {
            poc.selected = this.job.pointOfContactUserId === poc.userId;
        });
        this.selectedPocs = _.filter(this.pocs, (poc: any) => poc.selected === true);
    }

    onPocSelected() {
        this.job.pointOfContactUserId = (this.selectedPocs && this.selectedPocs.length > 0) ? this.selectedPocs[0].userId : null;
        this.validateStepTwo();
    }

    getRecruiters(successCallback?: () => void) {
        const clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        const requisitionId = _.isNull(this.job.id) ? null : this.job.id;
        const clientOrBuIds: any[] = [];
        const requisitionNumbers: any[] = [];
        const isUploadOrEditReq = true;
        this.jobService.getAllRecruiters(this.userDetails, this.userDetails.company, clientOrBUId, requisitionId, clientOrBuIds, requisitionNumbers, isUploadOrEditReq, (data: any) => {
            this.recruiterList = data.recruiters;
            this.hiringManagerList = data.hiringManagers;
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    private _setRecruitersAndHiringManagers() {
        this.recruiterList.forEach((val: any) => {
            val.selected = this.job.recruiters.indexOf(val.userId) > -1;
        });

        this.hiringManagerList.forEach((val: any) => {
            const managers = _.filter(this.job.hiringManagers, (manager: any) => manager.id === val.userId);
            if (managers.length > 0) {
                val.selected = true;
                val.isPrimary = managers[0].isPrimary;
                if (val.isPrimary) {
                    this.primaryHiringManagerId = val.userId;
                }
            } else {
                val.selected = false;
            }
        });
        this.primaryHiringManagerList = _.filter(this.hiringManagerList, (manager: any) => manager.selected === true);
        this.selectedRecruiters = _.filter(this.recruiterList, (val: any) => val.selected === true);
        this.selectedHiringManagers = _.filter(this.hiringManagerList, (manager: any) => manager.selected === true);
        if (this.isCorporate) {
            this._setPoc();
        }
    }

    private _setPoc() {
        this.sharedJobPocs = [];
        const pocs = _.filter(this.recruiterList, (recruiter: any) => recruiter.selected === true);
        this.primaryHiringManagerList.forEach((hiringManager: any) => {
            if (hiringManager.isPrimary) {
                pocs.push(hiringManager);
            }
        });
        this.sharedJobPocs = _.cloneDeep(pocs);
        this.sharedJobPocs.forEach((poc: any) => {
            poc.selected = poc.userId === this.job.pointOfContactUserId;
        });
        this.selectedPocs = _.filter(this.sharedJobPocs, (poc: any) => poc.selected === true);
    }

    onRecruitersSelected() {
        this.job.recruiters = [];
        if (this.selectedRecruiters.length > 0) {
            this.selectedRecruiters.forEach((recruiter: any) => {
                this.job.recruiters.push(recruiter.userId);
            });
        }
        this.validateStepTwo();
        if (this.isCorporate) {
            this._setPoc();
        }
    }

    onHiringManagersSelected() {
        this.job.hiringManagers = [];
        if (this.selectedHiringManagers.length !== 0 && this.selectedHiringManagers.length > 1) {
            this.selectedHiringManagers.forEach((hiringManager: any) => {
                hiringManager.isPrimary = hiringManager.userId === this.primaryHiringManagerId;
                this.job.hiringManagers.push({ id: hiringManager.userId, isPrimary: hiringManager.isPrimary });
            });
            this.primaryHiringManagerList = _.cloneDeep(this.selectedHiringManagers);
        } else if (this.selectedHiringManagers.length === 1) {
            this.primaryHiringManagerId = this.selectedHiringManagers[0].userId;
            this.selectedHiringManagers[0].isPrimary = true;
            this.job.hiringManagers.push({ id: this.selectedHiringManagers[0].userId, isPrimary: this.selectedHiringManagers[0].isPrimary });
            this.primaryHiringManagerList = _.cloneDeep(this.selectedHiringManagers);
        }
        if (this.isCorporate) {
            this._setPoc();
        }
    }

    onPrimaryHiringManagerSelected(selectedHiringManager: any) {
        this.job.hiringManagers.forEach((manager: any) => {
            if (manager.id === selectedHiringManager.userId) {
                manager.isPrimary = true;
                this.primaryHiringManagerId = manager.id;
            } else {
                manager.isPrimary = false;
            }
        });
        this.primaryHiringManagerList.forEach((manager: any) => {
            manager.isPrimary = manager.userId === selectedHiringManager.userId;
        });
        this.validateStepTwo();
        if (this.isCorporate) {
            this._setPoc();
        }
    }

    isPrimaryHiringManagerSelected(): boolean {
        const managers = _.filter(this.job.hiringManagers, (manager: any) => manager.isPrimary === true);
        return managers.length > 0;
    }

    getBuVendors(successCallback?: () => void) {
        const buId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        this.jobService.getBuVendors(this.userDetails.company.companyId, buId, (data: any) => {
            this.vendorsList = data;
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    private _setBuVendors() {
        if (!this.job.vendorIds) {
            this.job.vendorIds = [];
        }
        this.vendorsList.forEach((vendor: any) => {
            vendor.selected = this.job.vendorIds.indexOf(vendor.vendorId) > -1;
        });
    }

    onVendorsSelected() {
        this.job.vendorIds = [];
        if (this.selectedVendors.length > 0) {
            this.selectedVendors.forEach((vendor: any) => {
                this.job.vendorIds.push(vendor.vendorId);
            });
        }
        this.validateStepTwo();
    }

    getAllJobTypes(successCallback?: () => void) {
        this.jobService.getAllJobTypes((data: any) => {
            this.jobTypeList = data;
            this.job.jobTypeLabel = (this.job.jobType && this.jobTypeList.length > 0) ? this.jobTypeList.filter((jobType: any) => jobType.value === this.job.jobType)[0].name : null;
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    private _setJobType() {
        if (angular.isDefined(this.job.jobType)) {
            for (let k = 0; k < this.jobTypeList.length; k++) {
                this.jobTypeList[k].selected = this.job.jobType === this.jobTypeList[k].value;
            }
        } else {
            for (let i = 0; i < this.jobTypeList.length; i++) {
                this.jobTypeList[i].selected = false;
            }
        }
        const selectedJobTypeArray = _.filter(this.jobTypeList, (jobType: any) => jobType.value === this.job.jobType);
        if (selectedJobTypeArray.length > 0) {
            this.selectedJobType = selectedJobTypeArray[0].name;
            this.selectedJobTypes = [selectedJobTypeArray[0]];
        } else {
            this.selectedJobType = null;
            this.selectedJobTypes = [];
        }
        this._setSalaryLabel();
    }

    private _setSalaryLabel() {
        this.salaryLabel = (this.selectedJobType === 'Contractor' || this.selectedJobType === 'Contract to Hire') ?
            (this.isCorporate ? 'Bill Rate' : 'Client/Bill Rate') : 'Salary';
        this._setSalaryRangeOptions();
    }

    private _setSalaryRangeOptions() {
        if (this.selectedJobType) {
            if (this.selectedJobType !== 'Full Time') {
                this.salaryDurationOptions = this.allSalaryDurationOptions.filter((salaryDuration: any) => salaryDuration.value !== 'PER_YEAR');
                if (!this.isJobTypeChanged) {
                    if (this.job.jobSalary && this.job.jobSalary.salaryDuration === 'PER_YEAR') {
                        this.salaryDurationOptions = [...this.allSalaryDurationOptions];
                    }
                } else {
                    if (!this.job.jobSalary) {
                        this.job.jobSalary = new JobSalary();
                        this.job.jobSalary.currency = 'USD';
                    }
                    this.job.jobSalary.salaryDuration = 'PER_HOUR';
                }
            } else {
                this.salaryDurationOptions = this.allSalaryDurationOptions.filter((salaryDuration: any) => salaryDuration.value === 'PER_YEAR');
                if (this.job.jobSalary) {
                    this.job.jobSalary.salaryDuration = 'PER_YEAR';
                }
            }
        } else {
            this.salaryDurationOptions = [...this.allSalaryDurationOptions];
        }
    }

    onJobTypeSelected(multiSelectAction?: string) {
        if (this.selectedJobTypes.length > 0) {
            if (!this.candidatesPresentOnJob) {
                this.job.jobType = this.selectedJobTypes[0].value;
                if (this.job.jobType !== 'CONTRACTOR' && this.job.jobType !== 'CONTRACTTOHIRE') {
                    this.job.contractDuration = null;
                }
                this.hasJobTypeChanged = true;
                this.isJobTypeChanged = true;
                this._massageWorkflowStepsOrder();
            } else if (multiSelectAction === 'close') {
                this._showcandidatesPresentOnJobWarningMessage(() => {
                    this._setJobType();
                });
            }
        } else if (this.candidatesPresentOnJob && multiSelectAction === 'close') {
            this._showcandidatesPresentOnJobWarningMessage(() => {
                this._setJobType();
            });
        } else {
            this.job.jobType = null;
        }
        this.validateStepTwo();
    }

    private _showcandidatesPresentOnJobWarningMessage(successCallback?: () => void) {
        this.alertsAndNotificationsService.showAlertWithCallBack('Warning!', 'Cannot change the Job Type as candidate(s) exist in the Requisition!', 'warning', () => {
            if (successCallback) {
                successCallback();
            }
        });
    }

    onSalaryTypeChange(salaryType: string) {
        if (this.job.jobSalary.salaryDuration === undefined) {
            this.job.jobSalary = new JobSalary();
            this.job.jobSalary.currency = 'USD';
            this.job.jobSalary.salaryType = salaryType;
            this._setSalaryRangeOptions();
        }
        if (!this.job.jobSalary.currency) {
            this.job.jobSalary.currency = 'USD';
        }
    }

    getAllWorkLocations(successCallback?: () => void) {
        this.jobService.getWorkLocations((data: any) => {
            this.workLocationsList = data.filter((location: any) => location.name !== 'No Work Location');
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    private _setWorkLocations() {
        if (this.job.workLocationIds) {
            this.workLocationsList.forEach((workLocation: any) => {
                workLocation.selected = this.job.workLocationIds.indexOf(workLocation.id) > -1;
            });
            this.selectedWorkLocationsList = _.filter(this.workLocationsList, (workLocation: any) => workLocation.selected === true);
        }
    }

    onWorkLocationsSelected() {
        this.job.workLocationIds = [];
        if (this.selectedWorkLocationsList.length > 0) {
            this.selectedWorkLocationsList.forEach((workLocation: any) => {
                this.job.workLocationIds.push(workLocation.id);
            });
        }
    }

    getAllSponsorshipTypes(successCallback?: () => void) {
        this.jobService.getAllSponsorshipTypes((data: any) => {
            this.sponsorshipList = data.filter((sponsorship: any) => sponsorship.value !== 'NO_WORK_AUTHORIZATION_SPECIFIED');
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    private _setSponsorshipType() {
        if (this.sponsorshipList && this.job.sponsorships) {
            this.selectedSponsorships = _.cloneDeep(this.job.sponsorships);
            this.sponsorshipList.forEach((val: any) => {
                val.selected = this.job.sponsorships.indexOf(val.value) > -1;
            });
        }
    }

    private _setSponsorshipSelectedDefault(sponsorshipChanged: boolean) {
        if ((this.sponsorshipList && _.isNull(this.job.sponsorships)) || sponsorshipChanged) {
            this.selectedSponsorships = ['CITIZENONLY', 'PERMANENTRESIDENTORGREENCARD'];
            this.sponsorshipList.forEach((val: any) => {
                val.selected = this.selectedSponsorships.indexOf(val.value) > -1;
            });
            this.job.sponsorships = _.cloneDeep(this.selectedSponsorships);
        }
    }

    onSponsorshipProvidedSelected() {
        if (!this.job.sponsorshipProvided) {
            this._setSponsorshipSelectedDefault(true);
            this.validateStepTwo();
        }
    }

    onSponsorshipSelected(index: number, sponsorship: any) {
        this.job.sponsorships = [];
        if (sponsorship.selected === true) {
            this.selectedSponsorships.push(sponsorship.value);
        } else {
            this.selectedSponsorships = this.selectedSponsorships.filter((item: any) => item !== sponsorship.value);
        }
        this.job.sponsorships = _.cloneDeep(this.selectedSponsorships);
        this.validateStepTwo();
    }

    updateLocation() {
        const locationObject = _.cloneDeep(this.job.location);
        this.uploadReqUpdateLocationModalService.show(this.job.id, locationObject, (savedLocationObject: any) => {
            this.isJobLocationChanged = true;
            this._updateLocationCallback(savedLocationObject);
        }, () => {
            this.job.locationLabel = '';
            this.job.location = null;
            this.isJobLocationChanged = true;
        });
    }

    private _updateLocationCallback(locationObject: any) {
        this.job.locationLabel = locationObject.city + ', ' + locationObject.state + ', ' + locationObject.zipCode;
        this.job.location = locationObject;
    }

    showJobProfile() {
        this.uploadReqJobProfileModalService.show(this.job.id);
    }

    addEditEndClient(type: string) {
        this.endClientSearchText = type === 'Add' ? '' : this.endClientSearchText;
        this.isManageEndClient = (type === 'Manage' && this.endClient) ? true : false;

        if (type === 'Edit' || type === 'Delete') {
            this.isManageEndClient = false;
            this.addEditClientName = _.cloneDeep(this.endClient[0].name);
            this.associatedEdClientReqDetails = type === 'Delete' ? _.cloneDeep(this.endClient[0].associatedReqDetails) : [];
        } else {
            this.addEditClientName = '';
        }

        if (type === 'Add' || type === 'Edit' || type === 'Delete') {
            this.uploadReqAddEditEndClientModalService.show(type, this.addEditClientName, this.isEndClientNameValid, this.associatedEdClientReqDetails, (t: string, addEditClientName: string, successCallback: () => void) => {
                this.addEditClientName = addEditClientName;
                this._addEditEndClient(t, addEditClientName, successCallback);
            });
        }
    }

    private _addEditEndClient(type: string, endClientName: string, successCallback?: () => void) {
        if (type === 'Add') {
            this.endClient = null;
            const tempEndClient = {
                companyId: this.companyId,
                name: endClientName
            };
            this.jobService.addEndClient(this.userId, tempEndClient, (data: any) => {
                if (data) {
                    this.alertsAndNotificationsService.showBannerMessage(`${type}ed End Client Successfully.`, 'success');
                    this.endClient = [{
                        companyId: data.companyId,
                        name: data.name,
                        id: data.id
                    }];
                    this.job.endClientId = data.id;
                    if (successCallback) {
                        successCallback();
                    }
                }
            }, (error: any) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        } else if (type === 'Edit') {
            const endClientCopy: any = _.cloneDeep(this.endClient);
            const tempEndClient: any = {
                id: endClientCopy[0].id,
                name: endClientName,
                companyId: endClientCopy[0].companyId ? endClientCopy[0].companyId : this.companyId
            };
            this.endClient = null;
            this.jobService.editEndClient(this.userId, this.job.id, tempEndClient, (data: any) => {
                if (data) {
                    this.endClient = [{
                        companyId: data.companyId,
                        name: data.name,
                        id: data.id,
                        associatedReqDetails: data.associatedReqDetails
                    }];
                    this.job.endClientId = data.id;
                    if (successCallback) {
                        successCallback();
                    }
                }
            }, (error: any) => {
                this.endClient = endClientCopy;
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        } else if (type === 'Delete') {
            this.jobService.deleteEndClient(this.endClient[0].id, (data: any) => {
                if (data) {
                    this.alertsAndNotificationsService.showBannerMessage(`${type}d End Client Successfully.`, 'success');
                    this.endClient = null;
                    this.job.endClientId = null;
                    if (successCallback) {
                        successCallback();
                    }
                }
            }, (error: any) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }

    private _getEndClientTypeAhead(searchTerm: string) {
        return this.jobService.getEndClients(this.companyId, this.job.id, searchTerm).then((data: any) => data);
    }

    private _endClientTypeAheadTagAdded(tag: any) {
        this.addEditClientName = tag.name;
        if (tag.id) {
            this.job.endClientId = tag.id;
        }
    }

    private _endClientTypeAheadTagRemoved() {
        this.isManageEndClient = false;
        this.endClient = null;
        this.job.endClientId = null;
    }

    onEndClientSearch(term: string) {
        if (!term) {
            this.endClientTypeAheadResults = [];
            return;
        }
        this.isLoadingEndClientSearch = true;
        this._getEndClientTypeAhead(term).then((data: any) => {
            this.endClientTypeAheadResults = data || [];
            this.isLoadingEndClientSearch = false;
        }, () => {
            this.isLoadingEndClientSearch = false;
        });
    }

    onEndClientChange(items: any[]) {
        if (items && items.length > 0) {
            this.endClient = [items[0]];
            this._endClientTypeAheadTagAdded(items[0]);
        } else {
            this._endClientTypeAheadTagRemoved();
        }
    }

    onVoiceTranscript(transcript: string) {
        this.job.requisitionNote = this.job.requisitionNote ? this.job.requisitionNote + ' ' + transcript : transcript;
    }

    receiveFormalizedComment(event: string) {
        this.job.requisitionNote = event;
    }

    validateStepTwo() {
        setTimeout(() => {
            if (this.step2Submitted) {
                if (!this.step2RequiredFieldsValid || (this.job.jobType == null) || (this.job.recruiters.length === 0) ||
                    (this.job.sponsorshipProvided && this.job.sponsorships.length === 0) ||
                    (this.job.hiringManagers.length > 0 && !this.isPrimaryHiringManagerSelected()) ||
                    (this.job.vendorIds.length > 0 && _.isNull(this.job.pointOfContactUserId))) {
                    this.step2Error.hasErrorFlag = true;
                    this.step2Error.errorMessage = 'Please enter all mandatory fields.';
                } else {
                    this.step2Error.hasErrorFlag = false;
                    this.step2Error.errorMessage = '';
                }
            }
        }, 100);
    }

    private _hasRecruitersBeingUnAssigned(): boolean {
        return this.step2DetailsTempObject.recruiters.length > this.job.recruiters.length;
    }

    private _hasVendorsBeingUnAssigned(): boolean {
        return this.step2DetailsTempObject.vendorIds.length > this.job.vendorIds.length;
    }

    private _getAssignedRecruitersWarningMessage(): string {
        const removedRecruiterIds = _.difference(this.step2DetailsTempObject.recruiters, this.job.recruiters);
        const recruiterNames: string[] = [];
        removedRecruiterIds.forEach((recruiterId: any) => {
            this.recruiterList.forEach((recruiter: any) => {
                if (recruiterId === recruiter.userId) {
                    recruiterNames.push(recruiter.firstName + recruiter.lastName);
                }
            });
        });
        let message = '<b>';
        const totalCount = recruiterNames.length;
        recruiterNames.forEach((name: string, index: number) => {
            if (index === totalCount - 1) {
                message = message + name;
            } else if (index === totalCount - 2) {
                message = message + name + ' & ';
            } else {
                message = message + name + ', ';
            }
        });
        const messageEnd = totalCount > 1 ? '</b> shall be removed as assigned recruiters from all the candidates in the requisition. ' : '</b> shall be removed as assigned recruiter from all the candidates in the requisition. ';
        return message + messageEnd;
    }

    private _getVendorsRemovedWarningMessage(): string {
        const removedVendorIds = _.difference(this.step2DetailsTempObject.vendorIds, this.job.vendorIds);
        const vendorNames: string[] = [];
        removedVendorIds.forEach((vendorId: any) => {
            this.vendorsList.forEach((vendor: any) => {
                if (vendorId === vendor.vendorId) {
                    vendorNames.push(vendor.vendorName);
                }
            });
        });
        let message = 'All the candidates, if any, related to <b>';
        const totalCount = vendorNames.length;
        vendorNames.forEach((name: string, index: number) => {
            if (index === totalCount - 1) {
                message = message + name;
            } else if (index === totalCount - 2) {
                message = message + name + ' & ';
            } else {
                message = message + name + ', ';
            }
        });
        const messageEnd = totalCount > 1 ? '</b> vendors will be released. ' : '</b> vendor will be released. ';
        return message + messageEnd;
    }

    private _showWarningMessage(warningMessage: string, saveCallback: () => void, cancelCallback: () => void) {
        this.alertsAndNotificationsService.showConfirm('Warning!', warningMessage + '<br>Do you still want to continue?', 'warning', true, saveCallback, cancelCallback);
    }

    private _showRecruitersUnAssignedWarning(saveCallback: () => void, cancelCallback: () => void) {
        this._showWarningMessage(this._getAssignedRecruitersWarningMessage(), saveCallback, cancelCallback);
    }

    private _showVendorsRemovedWarning(saveCallback: () => void, cancelCallback: () => void) {
        this._showWarningMessage(this._getVendorsRemovedWarningMessage(), saveCallback, cancelCallback);
    }

    private _advanceFromStepTwo() {
        if (this.step2RequestWasInProgressFlag) {
            this.step2RequestWasInProgressFlag = false;
            this.currentStep = 3;
            return;
        }
        if (!this._isStepDataValid(2)) {
            this.step2Submitted = true;
            this.step2Error.hasErrorFlag = true;
            this.step2Error.errorMessage = 'Please enter all mandatory fields.';
            return;
        }
        if (this._hasStepDataChanged(2)) {
            if (this._hasRecruitersBeingUnAssigned() || this._hasVendorsBeingUnAssigned()) {
                if (this._hasRecruitersBeingUnAssigned() && this._hasVendorsBeingUnAssigned()) {
                    const warningMessage = this._getAssignedRecruitersWarningMessage() + '<br><br>' + this._getVendorsRemovedWarningMessage();
                    this._showWarningMessage(warningMessage, () => {
                        this._saveStep2AndMoveToNextStep();
                    }, () => {
                        this.job.vendorIds = _.cloneDeep(this.step2DetailsTempObject.vendorIds);
                        this._setBuVendors();
                        this.job.recruiters = _.cloneDeep(this.step2DetailsTempObject.recruiters);
                        this._setRecruitersAndHiringManagers();
                    });
                } else if (this._hasVendorsBeingUnAssigned()) {
                    this._showVendorsRemovedWarning(() => {
                        this._saveStep2AndMoveToNextStep();
                    }, () => {
                        this.job.vendorIds = _.cloneDeep(this.step2DetailsTempObject.vendorIds);
                        this._setBuVendors();
                    });
                } else {
                    this._showRecruitersUnAssignedWarning(() => {
                        this._saveStep2AndMoveToNextStep();
                    }, () => {
                        this.job.recruiters = _.cloneDeep(this.step2DetailsTempObject.recruiters);
                        this._setRecruitersAndHiringManagers();
                    });
                }
            } else {
                this._saveStep2AndMoveToNextStep();
            }
        } else {
            // step 2 data unchanged - advance without saving, matching the pre-existing legacy
            // wizard behavior for the "no changes" branch of case 2 in `_initUploadWizard`.
            if (!(this.editModeFlag && this.workflowStepsSavedFlag) || this.hasClientOrBuChanged || this.hasJobTypeChanged) {
                this.getAllTechAssessments(() => {
                    this.getAllValueAssessments(() => {
                        this.getLicensePreferences(() => {
                            this._createStepTempObject(3);
                            this._createStepTempObject(4);
                            this._createWorkflowSliders(() => {
                                this._massageWorkflowStepsOrder();
                                this.hasClientOrBuChanged = false;
                                this.hasJobTypeChanged = false;
                            });
                            this.currentStep = 3;
                        });
                    });
                });
            } else {
                this._createStepTempObject(3);
                this._createStepTempObject(4);
                this.currentStep = 3;
            }
        }
    }

    // ---------------------------------------------------------------------
    // Step 3 (workflow) navigation - `_advanceFromStepThree` mirrors the
    // legacy `case 3` block of the `actionclicked.fu.wizard` handler.
    // ---------------------------------------------------------------------

    private _advanceFromStepThree() {
        if (this.step3RequestWasInProgressFlag) {
            this.step3RequestWasInProgressFlag = false;
            this.currentStep = 4;
            return;
        }
        this._parseWorkflowStepsOrderBeforeSave();
        if (!this._isStepDataValid(3)) {
            this.step3Submitted = true;
            this.step3Error.hasErrorFlag = true;
            this.step3Error.errorMessage = 'Please enter all mandatory fields.';
            return;
        }
        if (this._hasStepDataChanged(3)) {
            if (this.currentJobStatus === 'DRAFT') {
                this._saveStep3AndMoveToNextStep(false);
            } else {
                if (this.hasMatchingMandatoryCriteriaChanged() || this.hasMissingPreferenceDetailsChanged()) {
                    this.alertsAndNotificationsService.showConfirm('Recalculate Score', 'Re-calculate the scores now?', 'warning', true, () => {
                        this._saveStep3AndMoveToNextStep(true);
                    }, () => {
                        this._saveStep3AndMoveToNextStep(false, () => {
                            this.isRecalcucateScoreNoClicked = true;
                        });
                    });
                } else {
                    this._saveStep3AndMoveToNextStep(false);
                }
            }
        } else {
            this.step3RequestWasInProgressFlag = true;
            this.utilityService.showLoadingModal('Loading...');
            this.getJobBoardParameters(() => {
                this.getRadiusAndRecencyOptions(() => {
                    this._createStepTempObject(4);
                    this.currentStep = 4;
                    this.utilityService.hideLoadingModal();
                }, () => {
                    this.step3RequestWasInProgressFlag = false;
                    this.utilityService.hideLoadingModal();
                    // do nothing. error message will show up. no move to next step.
                });
            }, () => {
                this.step3RequestWasInProgressFlag = false;
                this.utilityService.hideLoadingModal();
                // do nothing. error message will show up. no move to next step.
            });
        }
    }

    /** Consolidates the legacy `_updateDataAfterWorkflowStepsSavedNextClicked`/`_updateDataAfterWorkflowStepsSaved` duplication into one path. */
    private _saveStep3AndMoveToNextStep(isRerun: boolean, successCallback?: () => void) {
        this.step3RequestWasInProgressFlag = true;
        this.utilityService.showLoadingModal('Saving...');
        this._saveWorkflowSteps(isRerun, () => {
            this.getJobBoardParameters(() => {
                this.getRadiusAndRecencyOptions(() => {
                    this._createStepTempObject(4);
                    this.utilityService.hideLoadingModal();
                    this.currentStep = 4;
                    if (successCallback) {
                        successCallback();
                    }
                }, (error: any) => {
                    this.step3RequestWasInProgressFlag = false;
                    this.utilityService.hideLoadingModal();
                    if (this.authService.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }, (error: any) => {
                this.step3RequestWasInProgressFlag = false;
                this.utilityService.hideLoadingModal();
                if (this.authService.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }, (error: any) => {
            this.step3RequestWasInProgressFlag = false;
            this.utilityService.hideLoadingModal();
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    /** Explicit "Save" button handler for step 3 (mirrors legacy `wizardSaveStepData`'s `case 3`). */
    private _saveStep3(buttonType: string, isRerun: boolean = false) {
        this.disableAllButtonsFlag = true;
        this.savingFlag = true;
        this.utilityService.showLoadingModal('Saving...');
        this._saveWorkflowSteps(isRerun, () => {
            this.utilityService.hideLoadingModal();
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage('The Requisition details have been saved.', 'success');
            }
            this._createStepTempObject(3);
        }, (error: any) => {
            this.utilityService.hideLoadingModal();
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    private _saveWorkflowSteps(isRerun: boolean, successCallback: () => void, errorCallback: (error: any) => void) {
        const workflowStepsObject: any = {
            jobId: this.job.id,
            score: this.job.score,
            autoMatch: this.job.autoMatch,
            recruiterScreening: this.job.recruiterScreening,
            techAssessmentId: this.job.techAssessmentId,
            techAssessmentScore: this.job.techAssessmentScore,
            techAssessment: this.job.techAssessment,
            valueAssessmentId: this.job.valueAssessmentId,
            valueAssessment: this.job.valueAssessment,
            eduVerification: this.job.eduVerification,
            expVeification: this.job.expVeification,
            phoneScreen: this.job.phoneScreen,
            interview: this.job.interview,
            imageProctoring: this.job.imageProctoring,
            addProctoringImagesToReport: this.job.addProctoringImagesToReport,
            workflowStepsOrder: _.cloneDeep(this.job.workflowStepsOrder),
            includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
            includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
            tab: 'WORKFLOW_STEPS'
        };
        const updateFlag = (this.workflowStepsSavedFlag && (this.currentJobStatus === 'OPEN'));
        const clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        workflowStepsObject.actionType = this.editModeFlag ? 'UPDATE' : 'ADD';
        workflowStepsObject.source = this.editModeFlag ? 'EDITREQ' : 'CREATEREQ';
        const flagsUpdated = this._checkIfFlagsChanged(workflowStepsObject, this.workflowStepsTempObject);
        if (flagsUpdated) {
            workflowStepsObject.asyncActionType = this.currentJobStatus !== 'DRAFT' ? 'async' : null;
            workflowStepsObject.criteriaUpdated = false;
            workflowStepsObject.flagsUpdated = flagsUpdated;
            workflowStepsObject.rerunScore = isRerun;
            workflowStepsObject.recalculateLater = !isRerun;
        }
        this.jobService.createUpdateJobDetails(updateFlag, workflowStepsObject, this.job.company.id, clientOrBUId, this.userDetails.id, (data: any) => {
            this._updateRequisitionIcons(data.t);
            this.workflowStepsSavedFlag = true;
            this.isLicensePreferenceSet = true;
            if (flagsUpdated && this.currentJobStatus !== 'DRAFT') {
                const title = (!workflowStepsObject.rerunScore && workflowStepsObject.recalculateLater) ? 'Job updated successfully.' : 'Job matching in Progress';
                this.alertsAndNotificationsService.showAlertWithCallBack(title, data.message, 'success', () => {
                    if (workflowStepsObject.rerunScore && !workflowStepsObject.recalculateLater) {
                        this.$state.go('missioncontrol.requisitions');
                    }
                });
            }
            if (successCallback) {
                successCallback();
            }
            this.updateUserCache();
        }, (error: any) => {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }

    hasMatchingMandatoryCriteriaChanged(): boolean {
        return this.workflowStepsTempObject.includeCandidatesMatchingMandatoryCriteria !== this.job.includeCandidatesMatchingMandatoryCriteria;
    }

    hasMissingPreferenceDetailsChanged(): boolean {
        return this.workflowStepsTempObject.includeCandidatesWithNoAdditionalDetails !== this.job.includeCandidatesWithNoAdditionalDetails;
    }

    private _parseWorkflowStepsOrderBeforeSave() {
        angular.forEach(this.workflowStepsOrder, (steps: any[], jobType: string) => {
            const stepDetails: any[] = [];
            let renderIndex = 0;
            steps.forEach((step: any, index: number) => {
                if (index !== 0 && index !== steps.length - 1 && step.enabled) {
                    stepDetails.push(this.workflowStepsOrderToRender[jobType][renderIndex]);
                    renderIndex++;
                } else {
                    stepDetails.push(step);
                }
            });
            this.workflowStepsOrder[jobType] = _.cloneDeep(stepDetails);
        });
        const workflowStepsOrderCopy: any = _.cloneDeep(this.workflowStepsOrder);
        angular.forEach(this.workflowStepsOrder, (steps: any[], jobType: string) => {
            const stepsDetails: string[] = [];
            steps.forEach((step: any) => {
                stepsDetails.push(step.stepName);
            });
            workflowStepsOrderCopy[jobType] = _.cloneDeep(stepsDetails);
        });
        this.job.workflowStepsOrder = _.cloneDeep(workflowStepsOrderCopy);
    }

    // ---------------------------------------------------------------------
    // Step 4 (job boards) navigation - `_advanceFromStepFour` mirrors the
    // legacy `case 4` block of the `actionclicked.fu.wizard` handler: for a
    // fresh draft requisition (`isInitialStateDraft`), it moves straight to
    // step 5 (activate) with no candidate-count fetch; otherwise it pulls
    // resumes from job boards (if enabled) and fetches candidate counts
    // before showing the results pane, via `_pullResumesAndGetCandidateCountInOpen`.
    // ---------------------------------------------------------------------

    private _advanceFromStepFour() {
        if (this.step4RequestWasInProgressFlag) {
            this.step4RequestWasInProgressFlag = false;
            this.currentStep = 5;
            return;
        }
        if (this._hasStepDataChanged(4)) {
            this.step4RequestWasInProgressFlag = true;
            this.saveJobBoardsSettings('NEXT', () => {
                if (this.isInitialStateDraft) {
                    this.disableNextButtonFlag = !this.isActivateRequisitionEnabled;
                    this.currentStep = 5;
                } else {
                    if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                        this.alertsAndNotificationsService.showBannerMessage('Pulling and matching candidates from job boards', 'info');
                    }
                    this._pullResumesAndGetCandidateCountInOpen();
                }
            }, (error: any) => {
                this.step4RequestWasInProgressFlag = false;
                if (this.authService.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        } else {
            this.step4RequestWasInProgressFlag = true;
            if (this.isInitialStateDraft) {
                this.disableNextButtonFlag = !this.isActivateRequisitionEnabled;
                this.currentStep = 5;
            } else {
                if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                    this.alertsAndNotificationsService.showBannerMessage('Pulling and matching candidates from job boards', 'info');
                }
                this._pullResumesAndGetCandidateCountInOpen();
            }
        }
    }

    /** Explicit "Save" button handler for step 4 (mirrors legacy `wizardSaveStepData`'s `case 4`, not yet wired to a template trigger). */
    private _saveStep4(buttonType: string) {
        this.disableAllButtonsFlag = true;
        this.savingFlag = true;
        this.saveJobBoardsSettings(buttonType, () => {
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
        }, (error: any) => {
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    saveJobBoardsSettings(buttonType: string, successCallback: () => void, errorCallback: (error: any) => void) {
        this.utilityService.showLoadingModal('Saving...');
        const jobBoardsObject: any = {
            jobId: this.job.id,
            score: this.job.score,
            autoMatch: this.job.autoMatch,
            jobBoardDetails: this.job.jobBoardDetails,
            resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
            isResumePullEnabled: this.job.isResumePullEnabled,
            radius: this.job.radius,
            recency: this.job.recency,
            buttonType,
            tab: 'JOB_BOARDS'
        };
        const updateFlag = (this.jobBoardsSettingsSavedFlag && (this.currentJobStatus === 'OPEN'));
        const clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        jobBoardsObject.actionType = this.editModeFlag ? 'UPDATE' : 'ADD';
        jobBoardsObject.source = this.editModeFlag ? 'EDITREQ' : 'CREATEREQ';
        this.jobService.createUpdateJobDetails(updateFlag, jobBoardsObject, this.job.company.id, clientOrBUId, this.userDetails.id, () => {
            this.jobBoardsSettingsSavedFlag = true;
            this.isJobBoardDetailsSet = true;
            if (successCallback) {
                successCallback();
            }
            this.utilityService.hideLoadingModal();
            this.updateUserCache();
        }, (error: any) => {
            if (errorCallback) {
                errorCallback(error);
            }
            this.utilityService.hideLoadingModal();
        });
    }

    getJobBoardParameters(successCallback: (data: any) => void, errorCallback: (error?: any) => void) {
        this.jobService.getJobBoardParameters((data: any) => {
            this.jobBoardParameters = data;
            this._parseJobBoardParameters();
            successCallback(data);
        }, () => {
            // Preserved pre-existing legacy behavior: the underlying error is discarded here
            // (upload-req-page.component.js:1465-1473) - errorCallback is invoked with no argument.
            errorCallback();
        });
    }

    private _parseJobBoardParameters() {
        angular.forEach(this.job.jobBoardDetails, (val: any) => {
            if (!_.isNull(val.daxtraCode)) {
                const flags: boolean[] = [];
                const jobBoardsParams = this.jobBoardParameters.jobBoardParameterMap[val.daxtraCode];
                flags.push(true); // location supported by all job boards
                flags.push(this._isParameterSupported(jobBoardsParams, 'postcode'));
                flags.push(this._isParameterSupported(jobBoardsParams, 'radius'));
                flags.push(this._isParameterSupported(jobBoardsParams, 'jobType'));
                flags.push(this._isParameterSupported(jobBoardsParams, 'recency'));
                flags.push(this._isParameterSupported(jobBoardsParams, 'education'));
                flags.push(this._isParameterSupported(jobBoardsParams, 'industry'));
                flags.push(this._isParameterSupported(jobBoardsParams, 'salary'));
                val.flags = flags;
            }
        });
        this.jobBoardDetailsCopy = _.cloneDeep(this.job.jobBoardDetails);
        this.jobBoardsSettingsTempObject.jobBoardDetails = _.cloneDeep(this.job.jobBoardDetails);
    }

    private _isParameterSupported(jobBoardParameters: any, parameter: string): boolean {
        return jobBoardParameters.indexOf(parameter) !== -1;
    }

    getRadiusAndRecencyOptions(successCallback: (data: any) => void, errorCallback: (error?: any) => void) {
        this.jobService.getRadiusAndRecencyOptions((data: any) => {
            this.radiusOptions = data.radius;
            this.recencyOptions = data.recency;
            if (_.isNull(this.job.radius)) {
                this.job.radius = data.defaultRadius[0];
                this.isJobBoardDetailsSet = false;
            }
            if (_.isNull(this.job.recency)) {
                this.job.recency = data.defaultRecency[0];
            }
            successCallback(data);
        }, () => {
            // Preserved pre-existing legacy behavior: the underlying error is discarded here
            // (upload-req-page.component.js:1508-1527) - errorCallback is invoked with no argument.
            errorCallback();
        });
    }

    onUseJobBoardChange() {
        // Preserved pre-existing legacy no-op behavior (upload-req-page.component.js:4500-4504):
        // the body that would reset `job.jobBoardDetails` from `jobBoardDetailsCopy` is commented
        // out in the legacy source, so this handler intentionally does nothing.
    }

    /** Ported from legacy `onActivateRequisitionSwitchChange` - step 5's activate switch callback. */
    onActivateRequisitionSwitchChange() {
        this.disableNextButtonFlag = !this.isActivateRequisitionEnabled;
    }

    onJobBoardSelectionChange() {
        this.isJobBoardSelected = false;
        angular.forEach(this.job.jobBoardDetails, (val: any) => {
            if (val.enabled === true) {
                this.isJobBoardSelected = true;
            }
        });
    }

    /** Consolidates the legacy `_saveStep2AndMoveToNextStep`/`saveStep2Details('NEXT', ...)` duplication into one path. */
    private _saveStep2AndMoveToNextStep() {
        this.step2RequestWasInProgressFlag = true;
        this.utilityService.showLoadingModal('Saving...');
        this._saveStep2Details('NEXT', () => {
            if (!(this.editModeFlag && this.workflowStepsSavedFlag) || this.hasClientOrBuChanged || this.hasJobTypeChanged) {
                this.getAllTechAssessments(() => {
                    this.getAllValueAssessments(() => {
                        this.getLicensePreferences(() => {
                            this._createStepTempObject(3);
                            this._createStepTempObject(4);
                            this._createWorkflowSliders(() => {
                                this._massageWorkflowStepsOrder();
                                this.hasClientOrBuChanged = false;
                                this.hasJobTypeChanged = false;
                            });
                            this.utilityService.hideLoadingModal();
                            this.currentStep = 3;
                        });
                    });
                });
            } else {
                this.utilityService.hideLoadingModal();
                this.currentStep = 3;
            }
        }, (error: any) => {
            this.utilityService.hideLoadingModal();
            this.step2RequestWasInProgressFlag = false;
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    private _saveStep2(buttonType: string) {
        this.disableAllButtonsFlag = true;
        this.savingFlag = true;
        this.utilityService.showLoadingModal('Saving...');
        this._saveStep2Details(buttonType, () => {
            this.utilityService.hideLoadingModal();
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            if (this.authService.isOnline) {
                const successMessage = this.currentJobStatus === 'OPEN' ? 'The Requisition details have been saved.' : 'The Requisition details have been saved in Draft Status.';
                this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
            }
            this._createStepTempObject(2);
        }, (error: any) => {
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    private _saveStep2Details(buttonType: string, successCallback: () => void, errorCallback: (error: any) => void) {
        if (_.isNull(this.job.sponsorships)) {
            this.job.sponsorships = [];
        }
        if (_.isNull(this.job.workLocationIds)) {
            this.job.workLocationIds = [];
        }
        const clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        const step2DetailsObject: any = {
            jobId: this.job.id,
            title: this.job.title,
            isSharedClientRequisition: this.job.isSharedClientRequisition,
            sharedClientBuOrCorpId: this.job.sharedClientBuOrCorpId,
            clientOrBUId,
            requistionNumber: this.job.requisitionNumber,
            openings: this.job.openings,
            jobType: this.job.jobType,
            contractDuration: this.job.contractDuration,
            requisitionNote: this.job.requisitionNote,
            jobSalary: _.cloneDeep(this.job.jobSalary),
            sponsorships: this.job.sponsorships,
            sponsorshipProvided: this.job.sponsorshipProvided,
            workLocationIds: this.job.workLocationIds,
            recruiters: this.job.recruiters,
            hiringManagers: _.cloneDeep(this.job.hiringManagers),
            vendorIds: this.job.vendorIds,
            pointOfContactUserId: this.job.pointOfContactUserId,
            tab: 'ASSIGN_RECRUITERS',
            endClientId: this.job.endClientId
        };
        const updateFlag = (this.step2DetailsSavedFlag && (this.currentJobStatus === 'OPEN'));
        step2DetailsObject.actionType = this.editModeFlag ? 'UPDATE' : 'ADD';
        step2DetailsObject.source = this.editModeFlag ? 'EDITREQ' : 'CREATEREQ';

        if (this.isAsyncProcess && this.currentJobStatus !== 'DRAFT') {
            this.isUiCanExit = true;
            step2DetailsObject.asyncActionType = buttonType;
            this.jobService.createUpdateJobDetails(updateFlag, step2DetailsObject, this.job.company.id, clientOrBUId, this.userDetails.id, (data: any) => {
                this._updateRequisitionIcons(data.t);
            }, () => { });
            this.savingFlag = false;
            this.utilityService.hideLoadingModal();
            const message = 'Job match process has started in the background and will inform all users on the Requisition when its completed.';
            if (this.isRecalcucateScoreNoClicked) {
                this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => {
                    this.alertsAndNotificationsService.showAlertWithCallBack('Job matching in Progress', message, 'success', () => {
                        this.$state.go('missioncontrol.requisitions');
                    });
                });
            } else {
                this.alertsAndNotificationsService.showAlertWithCallBack('Job matching in Progress', message, 'success', () => {
                    this.$state.go('missioncontrol.requisitions');
                });
            }
            this.updateUserCache();
            if (successCallback) {
                successCallback();
            }
        } else {
            this.jobService.createUpdateJobDetails(updateFlag, step2DetailsObject, this.job.company.id, clientOrBUId, this.userDetails.id, (data: any) => {
                this._updateRequisitionIcons(data.t);
                this.editTitleFlag = false;
                this.editBUFlag = false;
                if (!clientOrBUId) {
                    this.req.clientOrBU = null;
                } else {
                    this.clientorbulist.forEach((val: any) => {
                        if (val.id === this.job.clientorbu.id) {
                            this.req.clientOrBU = val;
                        }
                    });
                }
                this.step2DetailsSavedFlag = true;
                if (successCallback) {
                    successCallback();
                }
                this.updateUserCache();
            }, (error: any) => {
                if (errorCallback) {
                    errorCallback(error);
                }
            });
        }
    }

    private _setWorkflowStepsOrderInIcons(workflowSteps: any) {
        const steps = [
            { key: 'recruiterScreening', label: 'Recruiter Screening' },
            { key: 'techAssessment', label: 'Tech Assessment' },
            { key: 'valueAssessment', label: 'Value Assessment' },
            { key: 'phoneScreen', label: 'Phone Screen' },
            { key: 'interview', label: 'Interview' }
        ];
        this.requisitionInfo.workflowSteps = steps
            .filter((step) => workflowSteps[step.key])
            .map((step) => step.label);
    }

    private _updateRequisitionIcons(data: any) {
        if (data && this.currentJobStatus !== 'DRAFT') {
            if (data.vendorIds && data.vendorIds.length > 0) {
                this.requisitionInfo.vendorsDetails = [];
                this.vendorsList.forEach((vendor: any) => {
                    if (data.vendorIds.includes(vendor.vendorId)) {
                        this.requisitionInfo.vendorsDetails.push({ id: vendor.vendorId, name: vendor.vendorName });
                    }
                });
            } else {
                this.requisitionInfo.vendorsDetails = [];
            }
            if (data.jobSalary) {
                this.job.requisitionSalaryDisplayMessage = this._getSalaryDetailsDisplayMessage(data.jobSalary, this.allSalaryDurationOptions);
            }
            this.requisitionInfo = {
                ...this.requisitionInfo,
                fourDotFiveIntelligentThresholdScore: data.fourDotFiveIntelligenceScore,
                autoMatedMatchSelected: data.licensePreferences.autoMatch,
                techAssessmentId: data.techAssessmentId,
                valueAssessmentId: data.valueAssessmentId
            };
            this._setWorkflowStepsOrderInIcons(data.licensePreferences);
        }
    }

    getAllTechAssessments(successCallback?: () => void) {
        let clientOrBuId = null;
        const isJobWorkflow = true;
        if (this.job.clientorbu) {
            clientOrBuId = this.job.clientorbu.id;
        }
        this.assessmentService.getAllTechAssessments(this.companyId, clientOrBuId, isJobWorkflow, (data: any) => {
            this.techAssessmentList = data;
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (successCallback) {
                successCallback();
            }
        });
    }

    getAllValueAssessments(successCallback?: () => void) {
        let clientOrBuId = null;
        const isJobWorkflow = true;
        if (this.job.clientorbu) {
            clientOrBuId = this.job.clientorbu.id;
        }
        this.assessmentService.getAllValueAssessments(this.companyId, clientOrBuId, isJobWorkflow, (data: any) => {
            if (data.length > 0) {
                this.valueAssessmentList = data;
            }
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (successCallback) {
                successCallback();
            }
        });
    }

    getLicensePreferences(successCallback?: () => void, errorCallback?: () => void) {
        this.jobService.getLicensePreferences(this.userDetails.company, this.job.clientorbu, this.job.id, (data: any) => {
            this.licensePreferenceDetails = data;
            if (_.isNull(this.job.licensePreferences) || _.isNull(this.job.licensePreferences.resumesToPullPerJobBoardCount)) {
                this.job.resumesToPullPerJobBoardCount = this.licensePreferenceDetails.resumesToPullPerJobBoardCount;
                this.resumesToPullPerJobBoardCountCopy = this.job.resumesToPullPerJobBoardCount;
                this.job.isResumePullEnabled = false;
                this.job.workflowStepsOrder = _.cloneDeep(data.workflowStepsOrder);
            }
            if (this.currentJobStatus !== 'DRAFT') {
                // Refresh requisition icons
                this.requisitionInfo.autoMatedMatchSelected = this.licensePreferenceDetails.autoMatch.licensePrefDetailsList[0].enabled &&
                    this.licensePreferenceDetails.autoMatch.licensePrefDetailsList[0].selected &&
                    (this.job.licensePreferences && this.job.licensePreferences.autoMatch);
            }
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (errorCallback) {
                errorCallback();
            }
        });
    }

    private _createWorkflowSliders(successCallback?: () => void) {
        // empty the existing sliders
        $('.slider-intelligence').empty();
        $('.slider-tech-assessment').empty();
        $(document).ready(() => {
            angular.forEach(this.licensePreferenceDetails, (val: any, key: string) => {
                switch (key) {
                    case 'fourDotFiveIntellList': {
                        this.intelligencePreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            value: val.licensePrefDetailsList[0].licensePrefMarkerValue,
                            company: val.licensePrefDetailsList[0].markerCompanyName
                        };
                        // if not in edit mode or if the score has not been set yet
                        if (!this.editModeFlag || _.isNull(this.job.score) || this.hasClientOrBuChanged) {
                            this.job.score = val.licensePrefDetailsList[0].licensePrefMarkerValue;
                        }
                        const sliderClass = '.slider-intelligence';
                        $(sliderClass).noUiSlider({
                            range: [0, 100],
                            start: [this.job.score],
                            handles: 1,
                            connect: 'lower',
                            step: 1,
                            slide: () => {
                                const sliderVal = $(sliderClass).val();
                                this.job.score = sliderVal;
                                $('#4dot5IntelligenceScoreDisplayValue').text(sliderVal).addClass('slider-bold');
                                this.isWorkFlowStep4Dot5ScoreChanged = true;
                            },
                            set: () => {
                                const sliderVal = $(sliderClass).val();
                                this.job.score = sliderVal;
                                $('#4dot5IntelligenceScoreDisplayValue').text(sliderVal).removeClass('slider-bold');
                            }
                        });
                        // set the value onto the intelligence score value span which displays the current value
                        $('#4dot5IntelligenceScoreDisplayValue').text(this.job.score);
                        break;
                    }
                    case 'techAssessmentList': {
                        this.techAssessmentPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            value: val.licensePrefDetailsList[0].licensePrefMarkerValue,
                            company: val.licensePrefDetailsList[0].markerCompanyName,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (this.editModeFlag) {
                            if (this.techAssessmentPreferences.enabled) {
                                // in edit mode, if license preferences have already been defined and techAssessment value is true
                                if (!_.isNull(this.job.licensePreferences) && this.job.licensePreferences.techAssessment) {
                                    this.job.techAssessment = true;
                                    // tech assessment score can be null for older assessments - then set the value to 0
                                    if (_.isNull(this.job.techAssessmentScore)) {
                                        this.job.techAssessmentScore = 0;
                                    }
                                } else {
                                    this.job.techAssessment = false;
                                    this.job.techAssessmentScore = 0;
                                    this.job.techAssessmentId = null;
                                }
                            } else {
                                this.job.techAssessment = false;
                                this.job.techAssessmentScore = 0;
                                this.job.techAssessmentId = null;
                            }
                        } else {
                            // in add mode, if enabled, set tech assessment to true and score to the default value
                            if (this.techAssessmentPreferences.enabled) {
                                this.job.techAssessment = true;
                                this.job.techAssessmentScore = val.licensePrefDetailsList[0].licensePrefMarkerValue;
                            } else {
                                this.job.techAssessment = false;
                                this.job.techAssessmentScore = 0;
                                this.job.techAssessmentId = null;
                            }
                        }
                        const techSliderClass = '.slider-tech-assessment';
                        $(techSliderClass).noUiSlider({
                            range: [0, 100],
                            start: [this.job.techAssessmentScore],
                            handles: 1,
                            connect: 'lower',
                            step: 1,
                            slide: () => {
                                const sliderVal = $(techSliderClass).val();
                                this.job.techAssessmentScore = sliderVal;
                                $('#techAssessmentScoreDisplayValue').text(sliderVal).addClass('slider-bold');
                            },
                            set: () => {
                                const sliderVal = $(techSliderClass).val();
                                this.job.techAssessmentScore = sliderVal;
                                $('#techAssessmentScoreDisplayValue').text(sliderVal).removeClass('slider-bold');
                            }
                        });
                        // set the value onto the intelligence score value span which displays the current value
                        $('#techAssessmentScoreDisplayValue').text(this.job.techAssessmentScore);
                        if (!this.techAssessmentPreferences.enabled) {
                            $('.slider-tech-assessment').attr('disabled', 'disabled');
                        }
                        break;
                    }
                    case 'valueAssessmentList': {
                        this.valueAssessmentPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            value: val.licensePrefDetailsList[0].licensePrefMarkerValue,
                            company: val.licensePrefDetailsList[0].markerCompanyName,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (this.editModeFlag) {
                            if (this.valueAssessmentPreferences.enabled) {
                                // in edit mode, if valueAssessment value is true
                                if (!_.isNull(this.job.licensePreferences) && this.job.licensePreferences.valueAssessment) {
                                    this.job.valueAssessment = true;
                                } else {
                                    this.job.valueAssessment = false;
                                    this.job.valueAssessmentId = null;
                                }
                            } else {
                                this.job.valueAssessment = false;
                                this.job.valueAssessmentId = null;
                            }
                        } else {
                            // in add mode, if enabled, set value assessment to true
                            if (this.valueAssessmentPreferences.enabled) {
                                this.job.valueAssessment = true;
                            } else {
                                this.job.valueAssessment = false;
                                this.job.valueAssessmentId = null;
                            }
                        }
                        break;
                    }
                    case 'verificationList': {
                        this.verificationPreferences = {};
                        angular.forEach(val.licensePrefDetailsList, (v: any) => {
                            switch (v.licensePrefEnum) {
                                case 'EDUCATION_VERIFICATION':
                                    this.verificationPreferences.educationVerificationName = v.name;
                                    this.verificationPreferences.educationVerificationEnabled = (v.enabled && v.selected);
                                    this.verificationPreferences.educationVerificationMessage = v.message;
                                    this.verificationPreferences.isCandidatesPresentOnStepEducationVerification = v.candidatesPresentOnStep;
                                    this.verificationPreferences.candidatesPresentMessageEducationVerification = v.messageForCandidatePresent;
                                    if (this.verificationPreferences.educationVerificationEnabled) {
                                        // edit mode and license preferences have been defined already
                                        if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                            this.job.eduVerification = this.job.licensePreferences.educationVerification;
                                        } else {
                                            this.job.eduVerification = true;
                                        }
                                    } else {
                                        this.job.eduVerification = false;
                                    }
                                    break;
                                case 'EXPERIENCE_VERIFICATION':
                                    this.verificationPreferences.experienceVerificationName = v.name;
                                    this.verificationPreferences.experienceVerificationEnabled = (v.enabled && v.selected);
                                    this.verificationPreferences.experienceVerificationMessage = v.message;
                                    this.verificationPreferences.isCandidatesPresentOnStepExperienceVerification = v.candidatesPresentOnStep;
                                    this.verificationPreferences.candidatesPresentMessageExperienceVerification = v.messageForCandidatePresent;
                                    if (this.verificationPreferences.experienceVerificationEnabled) {
                                        if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                            this.job.expVeification = this.job.licensePreferences.experienceVerification;
                                        } else {
                                            this.job.expVeification = true;
                                        }
                                    } else {
                                        this.job.expVeification = false;
                                    }
                                    break;
                                default:
                                    break;
                            }
                        });
                        break;
                    }
                    case 'phoneScreenList': {
                        this.phoneScreenPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (this.phoneScreenPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                this.job.phoneScreen = this.job.licensePreferences.phoneScreen;
                            } else {
                                this.job.phoneScreen = true;
                            }
                        } else {
                            this.job.phoneScreen = false;
                        }
                        break;
                    }
                    case 'interviewList': {
                        this.interviewPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (this.interviewPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                this.job.interview = this.job.licensePreferences.interview;
                            } else {
                                this.job.interview = true;
                            }
                        } else {
                            this.job.interview = false;
                        }
                        break;
                    }
                    case 'licenseAssessmentPreferences': {
                        this.imageProctoringPreferences = {
                            name: 'Image Proctoring',
                            enabled: (val.imageProctoringEnabled && val.imageProctoring),
                            message: val.imageProctoringMessage
                        };
                        this.addImagesToReportPreferences = {
                            name: 'Add Proctoring Images to Report',
                            enabled: (val.addProctoringImagesToReportEnabled && val.addProctoringImagesToReport),
                            message: val.addProctoringImagesToReportMessage
                        };
                        if (this.imageProctoringPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                this.job.imageProctoring = this.job.licensePreferences.imageProctoring;
                            } else {
                                this.job.imageProctoring = true;
                            }
                        } else {
                            this.job.imageProctoring = false;
                        }
                        if (this.addImagesToReportPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                this.job.addProctoringImagesToReport = this.job.licensePreferences.addProctoringImagesToReport;
                            } else {
                                this.job.addProctoringImagesToReport = true;
                            }
                        } else {
                            this.job.addProctoringImagesToReport = false;
                        }
                        break;
                    }
                    case 'recruiterScreening': {
                        this.recruiterScreeningPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (this.recruiterScreeningPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                this.job.recruiterScreening = this.job.licensePreferences.recruiterScreening;
                            } else {
                                this.job.recruiterScreening = true;
                            }
                        } else {
                            this.job.recruiterScreening = false;
                        }
                        break;
                    }
                    case 'autoMatch': {
                        const enabledFlag = val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected;
                        this.autoMatchingPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: enabledFlag,
                            message: val.licensePrefDetailsList[0].message
                        };
                        if (enabledFlag) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                if (!_.isNull(this.job.licensePreferences.autoMatch)) {
                                    this.job.autoMatch = this.job.licensePreferences.autoMatch;
                                } else {
                                    this.job.autoMatch = false;
                                }
                            } else {
                                this.job.autoMatch = true;
                                this.job.includeCandidatesMatchingMandatoryCriteria = true;
                            }
                        } else {
                            this.job.autoMatch = false;
                        }
                        // NOTE: legacy bug preserved - the original `autoMatch` case falls through into
                        // `default` with no `break` (upload-req-page.component.js:3672-3694). The fallthrough
                        // is a no-op since `default` does nothing, so behavior is unaffected either way.
                        break;
                    }
                    default:
                        break;
                }
                if (val !== null && val.licensePrefDetailsList !== undefined && val.licensePrefDetailsList[0].candidatesPresentOnStep) {
                    this.candidatesPresentOnJob = val.licensePrefDetailsList[0].candidatesPresentOnStep;
                }
            });
            if (successCallback) {
                successCallback();
            }
        });
    }

    private _massageWorkflowStepsOrder() {
        const jobType = _.filter(this.jobTypeList, (jt: any) => jt.value === this.job.jobType);
        if (jobType.length > 0) {
            this.selectedJobType = jobType[0].name;
            this._setJobType();
        }
        this.workflowStepsOrder = _.cloneDeep(this.job.workflowStepsOrder);
        this.isAnyWorkflowStepsEnabled = false;
        // setting id for dnd list to work
        angular.forEach(this.workflowStepsOrder, (steps: any, jobTypeKey: string) => {
            const stepsDetails: any[] = [];
            angular.forEach(steps, (step: string, index: number) => {
                let isStepEnabled = true;
                if (step === 'Recruiter Screening') {
                    isStepEnabled = this.job.recruiterScreening && this.recruiterScreeningPreferences.enabled;
                } else if (step === 'Tech Assessment') {
                    isStepEnabled = this.job.techAssessment && this.techAssessmentPreferences.enabled;
                } else if (step === 'Value Assessment') {
                    isStepEnabled = this.job.valueAssessment && this.valueAssessmentPreferences.enabled;
                } else if (step === 'Phone Screen') {
                    isStepEnabled = this.job.phoneScreen && this.phoneScreenPreferences.enabled;
                } else if (step === 'Interview') {
                    isStepEnabled = this.job.interview && this.interviewPreferences.enabled;
                }
                if (isStepEnabled) {
                    this.isAnyWorkflowStepsEnabled = true;
                }
                stepsDetails.push({ id: index, stepName: step, enabled: isStepEnabled, jobType: jobTypeKey });
            });
            this.workflowStepsOrder[jobTypeKey] = _.cloneDeep(stepsDetails);
        });
        this.workflowStepsOrderToRender = {};
        angular.forEach(this.workflowStepsOrder, (steps: any[], jobTypeKey: string) => {
            this.workflowStepsOrderToRender[jobTypeKey] = _.cloneDeep(
                steps.filter((step: any, index: number) => index !== 0 && index !== steps.length - 1 && step.enabled)
            );
        });
    }

    getAllJobBoards(successCallback?: () => void) {
        let buId = null;
        if (this.job.clientorbu && this.isCorporate) {
            buId = this.job.clientorbu.id;
        }
        this.resumeService.getResumeSourceTypes(this.companyId, buId, (data: any) => {
            if (data.length > 0) {
                this.isJobBoardSelected = true;
                angular.forEach(data, (val: any) => {
                    val.boardId = val.id;
                    val.enabled = true;
                    delete val.id;
                });
                if (successCallback) {
                    successCallback();
                }
            }
            this.jobBoardDetails = data;
            this.job.jobBoardDetails = _.cloneDeep(this.jobBoardDetails);
            this.jobBoardDetailsCopy = _.cloneDeep(this.job.jobBoardDetails);
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    private _setJobBoardDetails() {
        this.job.jobBoardDetails = _.cloneDeep(this.jobBoardDetails);
        if (!_.isNull(this.job.licensePreferences) && !_.isNull(this.job.licensePreferences.jobBoardDetails)) {
            angular.forEach(this.job.jobBoardDetails, (val: any) => {
                if (_.findIndex(this.job.licensePreferences.jobBoardDetails, { boardId: val.boardId, enabled: true }) === -1) {
                    val.enabled = false;
                }
            });
        }
        angular.forEach(this.job.jobBoardDetails, (val: any) => {
            if (val.enabled === true) {
                this.isJobBoardSelected = true;
            }
        });
        this.jobBoardDetailsCopy = _.cloneDeep(this.job.jobBoardDetails);
    }

    validateStepThree() {
        setTimeout(() => {
            if (this.step3Submitted && !this.step3RequiredFieldsValid) {
                this.step3Error.hasErrorFlag = true;
                this.step3Error.errorMessage = 'Please enter all mandatory fields.';
            } else {
                this.step3Error.hasErrorFlag = false;
                this.step3Error.errorMessage = '';
            }
        }, 100);
    }

    onRequiredFieldsValidChange(valid: boolean) {
        this.step3RequiredFieldsValid = valid;
        this.validateStepThree();
    }

    onAssessmentChange(assessmentType: string) {
        if (assessmentType === 'Technical' && this.job.techAssessmentId !== this.workflowStepsTempObject.techAssessmentId && this.sentTechnicalAssessmentsDetail.count > 0) {
            this._showCancelAssessmentsConfirmation(assessmentType);
        } else if (assessmentType === 'Value' && this.job.valueAssessmentId !== this.workflowStepsTempObject.valueAssessmentId && this.sentValueAssessmentsDetail.count > 0) {
            this._showCancelAssessmentsConfirmation(assessmentType);
        }
    }

    private _showCancelAssessmentsConfirmation(assessmentType: string) {
        const assessmentsCount = assessmentType === 'Technical' ? this.sentTechnicalAssessmentsDetail.count : this.sentValueAssessmentsDetail.count;
        const message = 'There are ' + assessmentsCount + ' ' + assessmentType + ' assessments that have already been sent out using the previous assessment. ' +
            'Do you want to cancel it? Cancellation notices will be sent out. This action cannot be undone!';
        this.alertsAndNotificationsService.showConfirm('Cancel Sent Assessments!', message, 'warning', true, () => {
            this.cancelSentAssessments(assessmentType);
        }, () => {
            this._resetAssessmentId(assessmentType);
        });
    }

    private _resetAssessmentId(assessmentType: string) {
        if (assessmentType === 'Technical') {
            this.job.techAssessmentId = this.workflowStepsTempObject.techAssessmentId;
        } else {
            this.job.valueAssessmentId = this.workflowStepsTempObject.valueAssessmentId;
        }
    }

    cancelSentAssessments(assessmentType: string) {
        const candidateAssessmentIds = assessmentType === 'Technical' ?
            this.sentTechnicalAssessmentsDetail.candidateAssessmentIds : this.sentValueAssessmentsDetail.candidateAssessmentIds;
        this.candidateService.cancelSentAssessments(candidateAssessmentIds, this.companyId, () => {
            this.alertsAndNotificationsService.showBannerMessage('All the assessments that were sent to candidates have been cancelled successfully', 'success');
            this.sentTechnicalAssessmentsDetail = new SentAssessmentDetail();
            this.sentValueAssessmentsDetail = new SentAssessmentDetail();
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    onImageProctoringCheckboxClick() {
        if (!this.job.imageProctoring) {
            this.job.addProctoringImagesToReport = false;
        }
    }

    onStepSelectionChange(event: { stepStatus: any, stepDetails: any, verificationStepName?: string }) {
        const { stepStatus, stepDetails, verificationStepName } = event;
        let showWarningMessage = false;
        if (stepDetails.isCandidatesPresentOnStep && !stepStatus && verificationStepName === undefined) {
            switch (stepDetails.name) {
                case 'Recruiter Screening':
                    this.job.recruiterScreening = true;
                    showWarningMessage = true;
                    break;
                case 'Tech Assessment':
                    this.job.techAssessment = true;
                    showWarningMessage = true;
                    break;
                case 'Value Assessment':
                    this.job.valueAssessment = true;
                    showWarningMessage = true;
                    break;
                case 'Phone Screen':
                    this.job.phoneScreen = true;
                    showWarningMessage = true;
                    break;
                case 'Interview':
                    this.job.interview = true;
                    showWarningMessage = true;
                    break;
                default:
                    break;
            }
            if (showWarningMessage) {
                this._showCandidatesAvailableOnStepWarning(stepDetails.candidatesPresentMessage, stepDetails.name);
            }
        }
        if (verificationStepName === 'Education Verification' && stepDetails.isCandidatesPresentOnStepEducationVerification && !stepStatus) {
            this.job.eduVerification = true;
            this._showCandidatesAvailableOnStepWarning(stepDetails.candidatesPresentMessageEducationVerification, stepDetails.name);
        }
        if (verificationStepName === 'Experience Verification' && stepDetails.isCandidatesPresentOnStepExperienceVerification && !stepStatus) {
            // eslint-disable-next-line
            (this as any).uploadReq.job.expVeification = true;
            // Preserved pre-existing legacy bug: `this.uploadReq` does not exist on the controller
            // (upload-req-page.component.js:4578), so this branch throws at runtime instead of
            // setting `expVeification` - preserved bug-for-bug rather than fixed.
            this._showCandidatesAvailableOnStepWarning(stepDetails.candidatesPresentMessageExperienceVerification, stepDetails.name);
        }
        this.validateStepThree();
        this._massageWorkflowStepsOrder();
    }

    private _showCandidatesAvailableOnStepWarning(message: string, stepName: string) {
        this.uploadReqWorkFlowStepWarningModalService.show(message, stepName);
    }

    // ---------------------------------------------------------------------
    // Step 5 (activate)/step 6 (results) logic, ported from the legacy
    // upload-req-page.component.js.
    // ---------------------------------------------------------------------

    getJobScoringJobStatus() {
        this.jobService.getJobScoringJobStatus(this.job.id, (data: any) => {
            this.scoringInProgress = data;
            if (this.scoringInProgress) {
                const message = 'Job matching process is in progress and will inform all users on the Requisition when its completed.';
                this.alertsAndNotificationsService.showAlertWithCallBack('Job matching in Progress', message, 'success', () => {
                    this.$state.go('missioncontrol.requisitions');
                });
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    private _getCandidateCountBeforeStep5(successCallback?: () => void, errorCallback?: () => void) {
        this.getCandidateCount(this.job.score, 'currentScore', () => {
            if (successCallback) {
                successCallback();
            }
        }, () => {
            if (errorCallback) {
                errorCallback();
            }
        });
    }

    /** Advances the wizard back one step - ported from the legacy `$("#uploadReqWizard").wizard('previous')` call. */
    private _advanceWizardToPreviousStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    private _createCountSliders() {
        $(document).ready(() => {
            // empty the existing sliders
            $('.slider-current-4dot5-score').empty();
            $('.slider-adjust-4dot5-score').empty();
            // create the current score slider
            const currentScoreSliderClass = '.slider-current-4dot5-score';
            $(currentScoreSliderClass).noUiSlider({
                range: [0, 100],
                start: [this.job.score],
                handles: 1,
                connect: 'lower',
                step: 1,
                slide: () => {
                    const val = $(currentScoreSliderClass).val();
                    $(currentScoreSliderClass).next('span').text(val).addClass('slider-bold');
                },
                set: () => {
                    const val = $(currentScoreSliderClass).val();
                    $(currentScoreSliderClass).next('span').text(val).removeClass('slider-bold');
                }
            });
            $('.slider-current-4dot5-score').next('span').text(this.job.score);
            // disable the current 4dot5 score slider.
            $('.slider-current-4dot5-score').attr('disabled', 'disabled');

            // create the slider to adjust the score.
            const adjustSliderClass = '.slider-adjust-4dot5-score';
            $(adjustSliderClass).noUiSlider({
                range: [0, 100],
                start: [this.job.score],
                handles: 1,
                connect: 'lower',
                step: 1,
                slide: () => {
                    const val = $(adjustSliderClass).val();
                    $(adjustSliderClass).next('span').text(val).addClass('slider-bold');
                    setTimeout(() => {
                        this.loadingAdjustedCandidatesCountFlag = true;
                    }, 50);
                },
                set: () => {
                    const val = $(adjustSliderClass).val();
                    $(adjustSliderClass).next('span').text(val).removeClass('slider-bold');
                    this.getCandidateCount(val, 'adjustedScore');
                }
            });
            $(adjustSliderClass).next('span').text(this.job.score);
        });
    }

    /**
     * Saves the adjusted 4dot5 score - ported from legacy `saveAdjusted4dot5Score`.
     */
    saveAdjusted4dot5Score(score: any, successCallback?: (data: any) => void, errorCallback?: (error: any) => void) {
        this.utilityService.showLoadingModal('Saving...');
        const saveObject: any = {
            jobId: this.job.id,
            score,
            candidatesToMatch: this.currentScoreCandidateCounts.candidatesToMatch
        };
        this.jobService.update4dot5Score(saveObject, (data: any) => {
            this.job.score = score;
            this.getCandidateCount(this.job.score, 'currentScore', () => {
                this._createCountSliders();
                this.utilityService.hideLoadingModal();
                if (successCallback) {
                    successCallback(data);
                }
            });
        }, (error: any) => {
            if (errorCallback) {
                errorCallback(error);
            }
            this.utilityService.hideLoadingModal();
        });
    }

    /** Sets the job status to open - ported from legacy `setJobStatusToOpen`. */
    private setJobStatusToOpen(successCallback?: () => void, errorCallback?: () => void) {
        this.jobService.setJobStatusToOpen(this.job.id, () => {
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    }

    /** Runs the job for scoring - ported from legacy `runJobForScoring`. */
    private runJobForScoring(successCallback?: () => void, errorCallback?: () => void) {
        this.jobService.runJobForScoring(this.job.company.id, this.job.id, this.job.transactionId, () => {
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    }

    /** Ported from legacy `getCandidateCount`. */
    getCandidateCount(score: any, scoreType: string, successCallback?: (data: any) => void, errorCallback?: (error: any) => void) {
        if (scoreType === 'adjustedScore') {
            this.loadingAdjustedCandidatesCountFlag = true;
        }
        const isNew = this.isInitialStateDraft;
        this.jobService.getCandidateCount(this.job.id, score, this.job.transactionId, isNew, (data: any) => {
            if (scoreType === 'currentScore') {
                // set both the current score and adjusted score candidate counts
                this.currentScoreCandidateCounts = data;
                this.adjustedScoreCandidateCounts = data;
            } else if (scoreType === 'adjustedScore') {
                // set only the adjusted score candidate counts
                this.adjustedScoreCandidateCounts = data;
                this.loadingAdjustedCandidatesCountFlag = false;
            }
            if (successCallback) {
                successCallback(data);
            }
        }, (error: any) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }

    /** Opens the transaction-candidates modal - ported from legacy `getCandidatesByRequisitionTransaction`. */
    getCandidatesByRequisitionTransaction(countType: string, scoreType: string) {
        this.candidatesBasedOnRequisitionTransaction = [];
        let score = this.job.score;
        if (scoreType === 'adjustedScore') {
            score = $('.slider-adjust-4dot5-score').val();
        }
        this.uploadReqTransactionCandidatesModalService.show(this.job.id, this.job.score, score, this.job.transactionId, countType, this.clientOrBuLabel);
    }

    /** Ported from legacy `sendOutreachEmailToCandidates`. */
    sendOutreachEmailToCandidates(candidateIds: any[]) {
        const candidateIdsAndCandidateTypes: any[] = [];
        if (candidateIds && candidateIds.length > 0) {
            candidateIds.forEach((candidateId: any) => {
                candidateIdsAndCandidateTypes.push({
                    id: candidateId,
                    candidateType: 'OWN_CANDIDATES'
                });
            });
        }
        if (this.isOutreachEnabled && this.sendOutreachEmail && candidateIds && candidateIdsAndCandidateTypes.length > 0) {
            const outreachObject: any = {
                candidates: candidateIdsAndCandidateTypes,
                userId: this.userId,
                companyId: this.companyId,
                clientOrBuId: this.currentJobStatus !== 'Draft' ? this.job.clientorbu.id : this.req.clientOrBU.id
            };
            this.candidateService.sendOutreachEmail(outreachObject, (data: any) => {
                this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
            }, (error: any) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }

    /** Ported from legacy `getJobBoardsSearchJobStatus`. */
    private getJobBoardsSearchJobStatus(successCallback: (jobInProgress: boolean) => void, errorCallback: (error: any) => void) {
        this.jobService.getGetMoreResumesJobStatus(this.job.id, (jobInProgress: boolean) => {
            successCallback(jobInProgress);
        }, (error: any) => {
            errorCallback(error);
        });
    }

    /** Ported from legacy `getResumesFromJobBoards`. */
    private getResumesFromJobBoards(successCallback?: () => void, errorCallback?: (error: any) => void) {
        this.jobService.getResumesFromJobBoards(this.job.id, this.job.jobBoardDetails, this.job.resumesToPullPerJobBoardCount, this.job.radius, this.job.recency, () => {
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }

    /**
     * Activates a draft requisition (sets it to OPEN, kicks off resume pull/matching and scoring) -
     * ported from legacy `_setJobStateToOpenAndRunForScoring`.
     */
    private _setJobStateToOpenAndRunForScoring(successCallback?: () => void, errorCallback?: () => void) {
        this.utilityService.showLoadingModal('Saving...');
        this.setJobStatusToOpen(() => {
            this.currentJobStatus = 'OPEN';
            this._pullResumesAndGetCandidateCountInDraft(() => {
                this.utilityService.hideLoadingModal();
                this.runJobForScoring(() => { });
                this._getCandidateCountBeforeStep5(() => {
                    this._createCountSliders();
                }, () => { });
                if (successCallback) {
                    successCallback();
                }
            }, () => {
                this.utilityService.hideLoadingModal();
                if (errorCallback) {
                    errorCallback();
                }
            });
        }, () => {
            this.utilityService.hideLoadingModal();
            if (errorCallback) {
                errorCallback();
            }
        });
    }

    /** Ported from legacy `_pullResumesAndGetCandidateCountInDraft`. */
    private _pullResumesAndGetCandidateCountInDraft(successCallback?: () => void, errorCallback?: () => void) {
        if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
            this.getJobBoardsSearchJobStatus((jobStatus: boolean) => {
                if (jobStatus === true) {
                    this.alertsAndNotificationsService.showBannerMessage("Candidates Fetch from Job Boards already <b>'INPROGRESS'</b>. Please try after sometime.", 'info');
                    if (successCallback) {
                        successCallback();
                    }
                } else {
                    this.getResumesFromJobBoards(() => {
                        let successMessage = '';
                        if (this.job.autoMatch) {
                            successMessage = 'Matched candidates from system ';
                            if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                                successMessage = successMessage + 'and pulled and matched candidates from job boards';
                            }
                        } else if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                            successMessage = 'Pulled candidates from job board';
                        }
                        this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                        if (successCallback) {
                            successCallback();
                        }
                    }, (error: any) => {
                        this.utilityService.hideLoadingModal();
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        if (errorCallback) {
                            errorCallback();
                        }
                    });
                }
            }, (error: any) => {
                this.utilityService.hideLoadingModal();
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                if (errorCallback) {
                    errorCallback();
                }
            });
        } else if (successCallback) {
            successCallback();
        }
    }

    /**
     * Pulls resumes from job boards (if enabled) then fetches candidate counts before showing the
     * results pane, for an already-`OPEN` requisition - ported from legacy
     * `_pullResumesAndGetCandidateCountInOpen`. Called from `_advanceFromStepFour` when
     * `currentJobStatus` is not `DRAFT`.
     */
    private _pullResumesAndGetCandidateCountInOpen() {
        if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
            this.getJobBoardsSearchJobStatus((jobStatus: boolean) => {
                if (jobStatus === true) {
                    this.alertsAndNotificationsService.showBannerMessage("Candidates Fetch from Job Boards already <b>'INPROGRESS'</b>. Please try after sometime.", 'info');
                    this.step4RequestWasInProgressFlag = false;
                } else {
                    this.getResumesFromJobBoards(() => {
                        this._getCandidateCountBeforeStep5(() => {
                            this._createCountSliders();
                            let successMessage = '';
                            if (this.job.autoMatch) {
                                successMessage = 'Matched candidates from system ';
                                if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                                    successMessage = successMessage + 'and pulled and matched candidates from job boards';
                                }
                                this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                            } else if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                                successMessage = 'Pulled and matched candidates from job boards';
                                this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                            }
                            this.currentStep = 5;
                        }, () => {
                            this.step4RequestWasInProgressFlag = false;
                        });
                    }, (error: any) => {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        this.step4RequestWasInProgressFlag = false;
                    });
                }
            }, (error: any) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                this.step4RequestWasInProgressFlag = false;
            });
        } else {
            this.utilityService.showLoadingModal('Loading...');
            this._getCandidateCountBeforeStep5(() => {
                this._createCountSliders();
                this.currentStep = 5;
                this.utilityService.hideLoadingModal();
            }, () => {
                this.step4RequestWasInProgressFlag = false;
                this.utilityService.hideLoadingModal();
            });
        }
    }
}
